<template>
	<v-container class="pa-0" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title>
            <span class="text-subtitle-1">Tickets por Area</span>
            <!--<v-divider class="mx-2" inset vertical></v-divider>
              <v-radio-group v-model="escuela" row>
                <v-radio label="Todos" :value="0"></v-radio>
                <v-radio label="Fast" :value="2"></v-radio>
                <v-radio label="Inbi" :value="1"></v-radio>
              </v-radio-group>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-checkbox v-model="urgente" :label="`Urgente`"></v-checkbox>-->
            <v-spacer></v-spacer>
            <v-btn class="mr-2" small dark color="green" @click="exportar()" tile>
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>
            <v-btn color="primary" @click="refrescarTickets" small tile>
              Actualizar
            </v-btn>
          </v-card-title>
          <v-card-text>
            <!-- Filtros -->
            <!--<v-row>
              <v-col cols="12" class="pt-0">
                <v-radio-group v-model="estatusFiltro" row dense hide-details small>
                  <v-radio color="orange" label="Abierto"    :value="1"></v-radio>
                  <v-radio color="blue"   label="Asignado"   :value="2"></v-radio>
                  <v-radio color="red"    label="Pendiente"  :value="3"></v-radio>
                  <v-radio color="grey"   label="Revisión"   :value="4"></v-radio>
                  <v-radio color="green"  label="Respondido" :value="5"></v-radio>
                  <v-radio color="yellow" label="Cerrado"    :value="6"></v-radio>
                  <v-radio color="black"  label="Rechazado"  :value="7"></v-radio>
                  <v-radio label="Todos" :value="8"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>-->

            <!-- Filtros adicionales: chips (estatus, fechas, clasificación); no sustituyen los controles de arriba -->
            <v-sheet class="mt-3 pa-3 rounded-lg ticket-area-filtros-chips" color="grey lighten-4" elevation="0">
              <div class="text-overline grey--text text--darken-1 mb-2">Filtros</div>

              <div class="text-caption grey--text text--darken-2 mb-1 d-flex flex-wrap align-center" style="gap: 16px;">
                <span class="d-flex align-center">
                  <v-icon x-small class="mr-1" color="blue-grey">mdi-calendar-range</v-icon>
                  Fecha de creación
                </span>
                <span class="d-flex align-center">
                  <v-icon x-small class="mr-1" color="blue-grey">mdi-magnify</v-icon>
                  Buscar en tabla
                </span>
                <span class="d-flex align-center">
                  <v-icon x-small class="mr-1" color="blue-grey">mdi-account-tie</v-icon>
                  Encargado
                </span>
              </div>
              <v-row dense class="mb-3 align-end">
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field
                    v-model="search"
                    placeholder="Buscar…"
                    outlined
                    hide-details
                    dense
                    single-line
                    clearable
                    prepend-inner-icon="mdi-magnify"
                    color="blue-grey"
                    class="ticket-area-buscar-compacto"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-autocomplete
                    v-model="filtroMotivo"
                    :items="opcionesMotivo"
                    item-text="text"
                    item-value="value"
                    label="Motivo"
                    dense
                    outlined
                    hide-details
                    color="blue-grey"
                    class="ticket-area-fecha"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-autocomplete
                    v-model="filtroPuesto"
                    :items="opcionesPuesto"
                    item-text="text"
                    item-value="value"
                    label="Puesto"
                    dense
                    outlined
                    hide-details
                    color="blue-grey"
                    class="ticket-area-fecha"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-select
                    v-model="filtroEncargado"
                    :items="opcionesEncargado"
                    item-text="nombre"
                    item-value="id"
                    label="Encargado"
                    dense
                    outlined
                    hide-details
                    clearable
                    color="blue-grey"
                    class="ticket-area-fecha"
                  />
                </v-col>
                <v-col cols="6" sm="6" md="2" lg="2">
                  <v-text-field
                    v-model="fechaFiltroDesde"
                    type="date"
                    label="Desde"
                    dense
                    outlined
                    hide-details
                    class="ticket-area-fecha"
                    color="blue-grey"
                  />
                </v-col>
                <v-col cols="6" sm="6" md="2" lg="2">
                  <v-text-field
                    v-model="fechaFiltroHasta"
                    type="date"
                    label="Hasta"
                    dense
                    outlined
                    hide-details
                    class="ticket-area-fecha"
                    color="blue-grey"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="2" lg="4" class="d-flex align-end pb-1">
                  <v-checkbox
                    v-if="esVisorPuestos"
                    v-model="soloMios"
                    label="Solo míos"
                    dense
                    hide-details
                    color="blue-grey"
                    class="mt-0 mr-4"
                  ></v-checkbox>
                  <v-btn
                    small
                    text
                    color="blue-grey darken-1"
                    class="mb-0"
                    @click="fechaFiltroDesde = ''; fechaFiltroHasta = ''; filtroEncargado = null; filtroMotivo = '__todos__'; filtroPuesto = '__todos__'"
                  >
                    <v-icon left small>mdi-backspace-outline</v-icon>
                    Limpiar filtros
                  </v-btn>
                </v-col>
              </v-row>

              <div class="text-caption grey--text text--darken-2 mb-1 d-flex align-center">
                <v-icon x-small class="mr-1" color="blue-grey">mdi-flag-outline</v-icon>
                Estatus
              </div>
              <div class="d-flex flex-wrap align-center mb-3" style="gap: 6px;">
                <v-chip
                  v-for="opt in chipsEstatusOpciones"
                  :key="'est-' + opt.value"
                  small
                  label
                  :outlined="estatusFiltro !== opt.value"
                  :color="estatusFiltro === opt.value ? opt.color : 'grey lighten-2'"
                  :text-color="estatusFiltro === opt.value ? 'white' : 'blue-grey darken-2'"
                  class="font-weight-medium"
                  @click="estatusFiltro = opt.value"
                >
                  <v-icon left x-small>{{ opt.icon }}</v-icon>
                  {{ opt.label }} ({{ conteosEstatus[opt.value] }})
                </v-chip>
              </div>
            </v-sheet>

            <v-sheet
              class="mt-3 px-4 py-3 rounded-lg ticket-area-metricas-bar d-flex flex-wrap align-center"
              elevation="1"
            >
              <div class="ticket-area-metrica-ticket d-flex align-center mr-4">
                <div class="ticket-area-metrica-icon mr-3">
                  <v-icon color="deep-purple darken-2">mdi-timer-sand</v-icon>
                </div>
                <div v-if="ticketMasViejoSinResponder">
                  <div class="text-overline deep-purple--text text--darken-2 font-weight-bold mb-0">
                    Ticket más viejo sin responder
                  </div>
                  <div class="ticket-area-metrica-valor deep-purple--text text--darken-4 font-weight-bold">
                    #{{ ticketMasViejoSinResponder.idticket }} · {{ ticketMasViejoTiempoTexto }}
                    <span
                      v-if="ticketMasViejoSinResponder.nombre_completo"
                      class="grey--text text--darken-2 font-weight-regular"
                    >
                      · {{ ticketMasViejoSinResponder.nombre_completo }}
                    </span>
                  </div>
                </div>
                <div v-else class="text-body-2 grey--text text--darken-2">
                  No tienes tickets por responder.
                </div>
              </div>

              <v-chip
                small
                color="green lighten-5"
                text-color="green darken-4"
                class="ticket-area-promedio-chip font-weight-bold"
              >
                <v-icon left small>mdi-clock-outline</v-icon>
                Tu tiempo promedio es: {{ promedioRespuestaTexto }}
              </v-chip>
            </v-sheet>
          </v-card-text>

  			  <v-data-table
  			    :headers="headers"
  			    :items="tickets"
            :item-class="itemRowBackground"
  			    class="elevation-0"
            dense
            :server-items-length="totalTickets"
            :options.sync="tableOptions"
            :footer-props="{
              'items-per-page-options': [25, 50, 100, 150],
              'items-per-page': 50,
            }"
            :loading="cargar || cargandoTabla"
            @update:options="onDataTableOptions"
  			  >

            <template v-slot:item.servicio_requerido="{ item }">
              <v-chip
                v-if="item.servicio_requerido"
                small
                dark
                :color="colorServicio(item.servicio_requerido)"
              >
                {{ item.servicio_requerido }}
              </v-chip>
            </template>

          	<template v-slot:item.estatus="{ item }">
  			      <v-chip small color="orange" dark v-if="item.estatus==1"> Abierto    </v-chip>
              <v-chip small color="blue"   dark v-if="item.estatus==2"> Asignado   </v-chip>
              <v-chip small color="red"    dark v-if="item.estatus==3"> Pendiente  </v-chip>
              <v-chip small color="grey"   dark v-if="item.estatus==4"> Revisión   </v-chip>
              <v-chip small color="green"  dark v-if="item.estatus==5"> Respondido </v-chip>
              <v-chip small color="yellow"      v-if="item.estatus==6"> Cerrado    </v-chip>
              <v-chip small color="black"  dark v-if="item.estatus==7"> Rechazado  </v-chip>
  			    </template>

            <template v-slot:item.fecha_apertura="{ item }">
              <span>{{ item.fecha_apertura_correccion }}</span>
            </template>

            <template v-slot:item.puesto_usuario="{ item }">
              <span>{{ item.puesto_usuario || 'Sin puesto' }}</span>
            </template>

            <template v-slot:item.id_unidad_negocio="{ item }">
              <v-chip small v-if="item.id_unidad_negocio==1" color="#2EDAD5"> INBI </v-chip>
              <v-chip small v-else color="#000D4A" dark> FAST </v-chip>
            </template>

            <template v-slot:item.ver="{ item }">
              <v-btn text small color="blue" @click="comentarTicket(item)" v-if="item.solo_lectura">
                <v-icon small left>mdi-comment-text-outline</v-icon> Comentar
              </v-btn>
              <template v-else>
                <!-- Ver respuesta del auxiliar -->
                <v-btn text @click="verRespuestaAuxi(item)" small v-if="item.estatus == 4 || item.estatus == 3 "> RESPONDER</v-btn>
                <!-- Responder directamente -->
                <v-btn text small @click="responder(item)"        v-if="item.estatus == 2 || item.estatus == 7 "> Responder</v-btn>
              </template>
            </template>

            <template v-slot:item.historial="{ item }">
              <v-btn color="primary" small @click="historialTicket(item)" icon><v-icon>mdi-file-document</v-icon></v-btn>
            </template>

  			    <template v-slot:item.actions="{ item }">
  			      <v-chip x-small outlined v-if="item.solo_lectura">Solo lectura</v-chip>
  			      <v-btn color="success" small @click="verMotivo(item)" v-else-if="!item.nombre_auxiliar && item.estatus!=6 && item.estatus != 5">
                Asignar
              </v-btn>
  			    </template>

  			    <template v-slot:no-data>
  			      <v-btn color="primary" @click="initialize" small>
  			        Reset
  			      </v-btn>
  			    </template>

  			  </v-data-table>
        </v-card>
			</v-col>
		</v-row>
    <!-- Asignar a un auxiliar -->
		<v-dialog v-model="dialogAsignarAux" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}: {{ ticket.idticket }}</span>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogAsignarAux=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <ResumenIaTicket :idticket="ticket.idticket" :auto="[1, 2].includes(Number(ticket.estatus))" />
          <v-container> 
            <v-row  class="mt-0">
              <v-col cols="8" class="pa-2">
                <p class="ma-0"><strong>Motivo de tu ticket</strong></p>
              </v-col>

              <label class="black--text" v-if="alumnos.length && i==0"><b>Alumnos</b></label>
              <v-data-table
                v-if="alumnos.length && i==0"
                :headers="headersAlumnos"
                :items="alumnos"
                class="elevation-0 mt-4 mb-4 ticket-etiquetas"
                :mobile-breakpoint="100"
                dense
                hide-default-footer
              >
              </v-data-table>
            </v-row>
            <mensajeIzq :respuestas="firstHistorial" :ticket="ticket"></mensajeIzq>
            <InfoAlumnoTicket
              :mostrar="esTicketAlumno"
              :cargando="cargandoInfoAlumno"
              :info="infoAlumno"
              :error="errorInfoAlumno"
            />
            <br> <br>
            <v-row>
              <v-col cols="12" >
                <v-autocomplete
                	outlined
                	dense
                  :items="auxiliares"
                  v-model="auxiliar"
                  label="Selecciona un auxiliar"
                  return-object
                  item-value="idauxi_area"
                  item-text="nombre_completo"
                ></v-autocomplete>
            	</v-col>
            </v-row>
            
          </v-container>
          <div class="pa-0 pb-2 d-flex flex-wrap" style="gap: 6px">
            <v-tooltip
              v-for="item in botonesReasignacionDepartamentos"
              :key="'asig-' + item.iddepartamento"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :color="item.color"
                  dark
                  x-small
                  @click="confirmarReasignarDepartamento(item)"
                >
                  {{ item.abreviatura }}
                </v-btn>
              </template>
              <span>reasignar</span>
            </v-tooltip>
          </div>
          <v-card-actions class="pa-0 d-flex flex-wrap">
            <v-btn color="blue"   dark small @click="cargarNotas()">Ver notas {{ mensajes.length }}</v-btn>
            <v-btn color="blue"   dark small @click="dialogHistorialReasignacion = true"><v-icon>mdi-file-document</v-icon> {{ historialAsignacion.length }}</v-btn>
            <!-- Info alumno: ahora se anexa al motivo al crear el ticket (API addTicket)
            <v-btn
              v-if="esTicketAlumno"
              color="teal"
              dark
              small
              :loading="cargandoInfoAlumno"
              @click="verInfoAlumno()"
            >
              Ver información
            </v-btn>
            -->
            <v-spacer></v-spacer>
            <v-btn color="success darken-1" dark small @click="save"> Guardar </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Reponder directamente un ticket sin asignar a un auxiliar -->
    <v-dialog v-model="dialogRespuesta" max-width="600px" @keydown.ctrl="pegar">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}: {{ ticket.idticket }}</span>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogRespuesta=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pb-0" v-for="(respuestas, i) in historial" :key="i">
          <v-container>
            <div v-if="i==0" class="d-flex flex-wrap align-center mb-4 ticket-etiquetas" style="gap: 8px">
              <v-chip small color="deep-purple" outlined>
                {{ ticket.motivo_concepto || 'Sin etiqueta' }}
              </v-chip>
              <v-chip
                v-if="ticket.servicio_requerido"
                small
                dark
                :color="colorServicio(ticket.servicio_requerido)"
              >{{ ticket.servicio_requerido }}</v-chip>
              <v-chip v-else small outlined>Sin servicio</v-chip>
            </div>
            <div v-if="i==0 && puedeCorregirReloj" class="mt-3">
              <div v-if="cargandoReloj" class="body-2 grey--text">Buscando las checadas y la evidencia…</div>
              <template v-else-if="relojPropuesta">
                <v-select
                  v-if="relojPropuesta.personas && relojPropuesta.personas.length > 1"
                  :value="relojTrabajador"
                  :items="relojPropuesta.personas"
                  item-text="nombre_completo"
                  item-value="id_trabajador"
                  label="Elige a la persona"
                  dense
                  filled
                  hide-details
                  class="mb-2"
                  @change="elegirTrabajadorReloj"
                ></v-select>
                <v-card v-if="relojPropuesta.puntos && relojPropuesta.puntos.length" outlined class="ai-suggestion mt-2">
                  <div class="ai-suggestion__head">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"></path><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"></path></svg>
                    Sugerencia de IA · Ajuste de reloj
                  </div>
                  <div class="ai-suggestion__body">
                    <ul class="body-2 pl-4 mb-0">
                      <li
                        v-for="(punto, n) in relojPropuesta.puntos"
                        :key="'reloj-' + n"
                        :class="punto.cumple ? '' : 'red--text text--darken-2'"
                      >{{ punto.resumen || (punto.texto.replace(/^¿|\?$/g, '') + ': ' + punto.detalle) }}</li>
                    </ul>
                    <div v-if="relojPropuesta.listo" class="body-2 mt-3">{{ fraseReloj() }}</div>
                  </div>
                  <div v-if="relojPropuesta.listo" class="ai-suggestion__actions">
                    <v-btn small color="deep-purple darken-2" dark class="mr-2 text-none" :disabled="aplicandoReloj" :loading="aplicandoReloj" @click="aceptarReloj">
                      Aplicar
                    </v-btn>
                    <v-btn small outlined class="text-none" :disabled="aplicandoReloj" @click="rechazarReloj">
                      Descartar
                    </v-btn>
                  </div>
                </v-card>
              </template>
            </div>
            <div v-if="i==0 && puedeAbrirGrupo" class="mt-3">
              <div v-if="cargandoGrupo" class="body-2 grey--text">Revisando el grupo…</div>
              <template v-else-if="grupoPropuesta">
                <div v-if="grupoPropuesta.grupos && grupoPropuesta.grupos.length > 1" class="body-2 mb-1">
                  Hay más de un grupo con ese nombre.
                </div>
                <v-select
                  v-if="grupoPropuesta.grupos && grupoPropuesta.grupos.length > 1"
                  :value="grupoElegido"
                  :items="grupoPropuesta.grupos"
                  item-text="grupo"
                  item-value="id_grupo"
                  label="Elige el grupo"
                  dense
                  filled
                  hide-details
                  class="mb-2"
                  @change="elegirGrupoTicket"
                ></v-select>
                <v-card v-if="(grupoPropuesta.puntos && grupoPropuesta.puntos.length) || grupoPropuesta.frase" outlined class="ai-suggestion mt-2">
                  <div class="ai-suggestion__head">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"></path><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"></path></svg>
                    Sugerencia de IA · Apertura de grupo
                  </div>
                  <div class="ai-suggestion__body">
                    <ul v-if="grupoPropuesta.puntos && grupoPropuesta.puntos.length" class="body-2 pl-4 mb-0">
                      <li
                        v-for="(punto, n) in grupoPropuesta.puntos"
                        :key="n"
                        :class="punto.cumple ? '' : 'red--text text--darken-2'"
                      >
                        <v-icon v-if="punto.calavera" small color="error">mdi-skull</v-icon>
                        {{ punto.resumen || (punto.texto.replace(/^¿|\?$/g, '') + ': ' + punto.detalle) }}
                      </li>
                    </ul>
                    <div v-else class="body-2">{{ grupoPropuesta.frase }}</div>
                  </div>
                  <div class="ai-suggestion__actions">
                    <v-btn small color="deep-purple darken-2" dark class="mr-2 text-none" :disabled="aplicandoGrupo" :loading="aplicandoGrupo" @click="aceptarGrupo">
                      Aceptar
                    </v-btn>
                    <v-btn small outlined class="text-none" :disabled="aplicandoGrupo" @click="rechazarGrupo">
                      Rechazar
                    </v-btn>
                  </div>
                </v-card>
              </template>
            </div>
            <!-- Cuadros automáticos: un esqueleto del mismo tamaño aparta su lugar mientras carga, así el ticket no brinca. -->
            <transition name="ticket-auto" mode="out-in">
            <div v-if="i==0 && puedeCorregirAlumno" :key="cargandoAlumno ? 'alumno-cargando' : 'alumno'" class="mt-3 mb-6">
              <v-card v-if="cargandoAlumno" outlined class="pa-3 ticket-auto-cargando" aria-busy="true">
                <span class="d-sr-only">Revisando al alumno</span>
                <v-skeleton-loader type="text" max-width="260"></v-skeleton-loader>
                <v-skeleton-loader type="text" max-width="340" class="mt-2"></v-skeleton-loader>
                <div class="d-flex mt-3"><v-skeleton-loader type="button" class="mr-2"></v-skeleton-loader><v-skeleton-loader type="button"></v-skeleton-loader></div>
              </v-card>
              <v-card v-else-if="alumnoPropuesta" outlined class="ai-suggestion">
                <div class="ai-suggestion__head">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"></path><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"></path></svg>
                  Sugerencia de IA
                </div>
                <div class="ai-suggestion__body">
                  <div v-if="alumnoPropuesta.alumno" class="ai-suggestion__title">
                    {{ partirNombreMatricula(alumnoPropuesta.alumno.nombre).nombre }}
                    <span v-if="partirNombreMatricula(alumnoPropuesta.alumno.nombre).matricula" class="ai-suggestion__badge">{{ partirNombreMatricula(alumnoPropuesta.alumno.nombre).matricula }}</span>
                  </div>
                  <dl v-if="(alumnoPropuesta.cambios || []).length" class="ai-suggestion__diff">
                    <template v-for="cambio in alumnoPropuesta.cambios">
                      <dt :key="cambio.campo + '-dt'">{{ cambio.etiqueta.replace(/^el /, '') }}</dt>
                      <dd :key="cambio.campo + '-dd'">
                        <span class="d-sr-only">Valor actual: </span>
                        <del>{{ cambio.actual || '(vacío)' }}</del>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"></path><path d="M13 6l6 6-6 6"></path></svg>
                        <span class="d-sr-only">Valor sugerido: </span>
                        <ins>{{ cambio.nuevo }}</ins>
                      </dd>
                    </template>
                  </dl>
                  <div v-if="alumnoPropuesta.aviso" class="body-2">{{ alumnoPropuesta.aviso }}</div>
                </div>
                <div v-if="alumnoPropuesta.listo" class="ai-suggestion__actions">
                  <v-btn small color="deep-purple darken-2" dark class="mr-2 text-none" @click="aceptarAlumno">Aplicar cambio</v-btn>
                  <v-btn small outlined class="text-none" @click="rechazarAlumno">Descartar</v-btn>
                </div>
              </v-card>
            </div>
            </transition>
            <transition name="ticket-auto" mode="out-in">
            <v-card v-if="i==0 && revisandoAcceso" key="acceso-cargando" outlined class="pa-3 mt-3 mb-6 ticket-auto-cargando" aria-busy="true">
              <span class="d-sr-only">Revisando el acceso</span>
              <v-skeleton-loader type="text" max-width="260"></v-skeleton-loader>
              <v-skeleton-loader type="text" max-width="340" class="mt-2"></v-skeleton-loader>
              <div class="d-flex mt-3"><v-skeleton-loader type="button" class="mr-2"></v-skeleton-loader><v-skeleton-loader type="button"></v-skeleton-loader></div>
            </v-card>
            <v-card v-else-if="i==0 && cambridgePropuesta && cambridgePropuesta.cargando" key="cambridge-cargando" outlined class="pa-3 mt-3 mb-6 ticket-auto-cargando" aria-busy="true">
              <span class="d-sr-only">Revisando los códigos Cambridge</span>
              <v-skeleton-loader type="text" max-width="260"></v-skeleton-loader>
              <v-skeleton-loader type="text" max-width="340" class="mt-2"></v-skeleton-loader>
              <div class="d-flex mt-3"><v-skeleton-loader type="button" class="mr-2"></v-skeleton-loader><v-skeleton-loader type="button"></v-skeleton-loader></div>
            </v-card>
            <v-card v-else-if="i==0 && cambridgePropuesta && (cambridgePropuesta.listo || cambridgePropuesta.aviso)" key="cambridge" outlined class="ai-suggestion mt-3 mb-6">
              <div class="ai-suggestion__head">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"></path><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"></path></svg>
                Sugerencia de IA · Códigos Cambridge
              </div>
              <div class="ai-suggestion__body">
                <div v-if="cambridgePropuesta.alumno" class="ai-suggestion__title">
                  {{ partirNombreMatricula(cambridgePropuesta.alumno).nombre }}
                  <span v-if="partirNombreMatricula(cambridgePropuesta.alumno).matricula" class="ai-suggestion__badge">{{ partirNombreMatricula(cambridgePropuesta.alumno).matricula }}</span>
                </div>
                <div class="body-2">
                  {{ cambridgePropuesta.aviso || (cambridgePropuesta.accion === 'asignar'
                    ? 'No tiene código. Se le asigna uno libre (quedan ' + cambridgePropuesta.libres + ').'
                    : 'Ya tiene código asignado. Se le comparten sus accesos.') }}
                </div>
              </div>
              <div v-if="!cambridgePropuesta.aviso" class="ai-suggestion__actions">
                <v-btn small color="deep-purple darken-2" dark class="mr-2 text-none" @click="aceptarCambridge">Aplicar</v-btn>
                <v-btn small outlined class="text-none" @click="rechazarCambridge">Descartar</v-btn>
              </div>
            </v-card>
            <v-card v-else-if="i==0 && vendedoraPropuesta && vendedoraPropuesta.cargando" key="vendedora-cargando" outlined class="pa-3 mt-3 mb-6 ticket-auto-cargando" aria-busy="true">
              <span class="d-sr-only">Revisando la vendedora</span>
              <v-skeleton-loader type="text" max-width="260"></v-skeleton-loader>
              <v-skeleton-loader type="text" max-width="340" class="mt-2"></v-skeleton-loader>
              <div class="d-flex mt-3"><v-skeleton-loader type="button" class="mr-2"></v-skeleton-loader><v-skeleton-loader type="button"></v-skeleton-loader></div>
            </v-card>
            <v-card v-else-if="i==0 && vendedoraPropuesta" key="vendedora" outlined class="ai-suggestion mt-3 mb-6">
              <div class="ai-suggestion__head">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"></path><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"></path></svg>
                Sugerencia de IA · Cambio de vendedora
              </div>
              <div class="ai-suggestion__body">
                <div v-if="vendedoraPropuesta.alumno" class="ai-suggestion__title">
                  {{ partirNombreMatricula(vendedoraPropuesta.alumno.nombre).nombre }}
                  <span v-if="partirNombreMatricula(vendedoraPropuesta.alumno.nombre).matricula" class="ai-suggestion__badge">{{ partirNombreMatricula(vendedoraPropuesta.alumno.nombre).matricula }}</span>
                </div>
                <div v-if="vendedoraPropuesta.aviso" class="body-2">{{ vendedoraPropuesta.aviso }}</div>
                <template v-else>
                  <v-select
                    v-if="vendedoraPropuesta.opciones.length > 1"
                    v-model="vendedoraElegida"
                    :items="vendedoraPropuesta.opciones"
                    item-text="nombre"
                    return-object
                    label="Vendedora nueva"
                    dense
                    filled
                    hide-details
                    class="mb-2"
                  ></v-select>
                  <dl v-if="vendedoraElegida" class="ai-suggestion__diff">
                    <dt>vendedora</dt>
                    <dd>
                      <span class="d-sr-only">Valor actual: </span>
                      <del>{{ vendedoraPropuesta.actual }}</del>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"></path><path d="M13 6l6 6-6 6"></path></svg>
                      <span class="d-sr-only">Valor sugerido: </span>
                      <ins>{{ vendedoraElegida.nombre }}</ins>
                    </dd>
                  </dl>
                </template>
              </div>
              <div v-if="!vendedoraPropuesta.aviso && vendedoraElegida" class="ai-suggestion__actions">
                <v-btn small color="deep-purple darken-2" dark class="mr-2 text-none" @click="aceptarVendedora">Aplicar cambio</v-btn>
                <v-btn small outlined class="text-none" @click="rechazarVendedora">Descartar</v-btn>
              </div>
            </v-card>
            <div v-else-if="i==0 && ((sucursalPropuesta && sucursalPropuesta.listo) || (contrasenaPropuesta && (contrasenaPropuesta.listo || contrasenaPropuesta.aviso)))" key="acceso">
            <v-card v-if="sucursalPropuesta && sucursalPropuesta.listo" outlined class="ai-suggestion mt-3 mb-6">
              <div class="ai-suggestion__head">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"></path><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"></path></svg>
                Sugerencia de IA · Acceso a sucursal
              </div>
              <div class="ai-suggestion__body">
                <div class="ai-suggestion__title">{{ sucursalPropuesta.usuario.nombre }}</div>
                <v-select
                  v-if="sucursalPropuesta.opciones.length > 1"
                  v-model="sucursalElegida"
                  :items="sucursalPropuesta.opciones"
                  item-text="plantel"
                  return-object
                  label="Elige la sucursal"
                  dense
                  filled
                  hide-details
                  class="mb-2"
                ></v-select>
                <div v-if="sucursalElegida" class="body-2">
                  {{ sucursalElegida.ya_tiene ? 'Ya tiene ' + sucursalElegida.plantel + '. Solo debe cerrar sesión y volver a entrar.' : 'Se le dará acceso a ' + sucursalElegida.plantel + '.' }}
                </div>
              </div>
              <div v-if="sucursalElegida" class="ai-suggestion__actions">
                <v-btn small color="deep-purple darken-2" dark class="mr-2 text-none" @click="aceptarSucursal">Aplicar</v-btn>
                <v-btn small outlined class="text-none" @click="rechazarSucursal">Descartar</v-btn>
              </div>
            </v-card>
            <v-card v-if="contrasenaPropuesta && (contrasenaPropuesta.listo || contrasenaPropuesta.aviso)" outlined class="ai-suggestion mt-3 mb-6">
              <div class="ai-suggestion__head">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"></path><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"></path></svg>
                Sugerencia de IA · Restablecer contraseña
              </div>
              <div class="ai-suggestion__body">
                <div v-if="contrasenaPropuesta.aviso" class="body-2">{{ contrasenaPropuesta.aviso }}</div>
                <v-select
                  v-else
                  v-model="contrasenaPersona"
                  :items="contrasenaPropuesta.personas"
                  :item-text="(p) => p.nombre + ' (' + p.usuario + ')'"
                  return-object
                  label="¿De quién?"
                  dense
                  filled
                  hide-details
                  class="mb-2"
                ></v-select>
                <div v-if="contrasenaPersona" class="body-2">
                  Se le pondrá una contraseña temporal a {{ contrasenaPersona.nombre }} y se escribirá en la respuesta.
                </div>
              </div>
              <div v-if="contrasenaPersona" class="ai-suggestion__actions">
                <v-btn small color="deep-purple darken-2" dark class="mr-2 text-none" @click="aceptarContrasena">Aplicar</v-btn>
                <v-btn small outlined class="text-none" @click="rechazarContrasena">Descartar</v-btn>
              </div>
            </v-card>
            </div>
            </transition>
            <v-sheet
              v-if="i==0 && esEliminacionAdeudo"
              outlined
              class="ai-suggestion mb-3"
            >
              <div class="ai-suggestion__head">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"></path><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"></path></svg>
                Sugerencia de IA · Eliminación de adeudo
              </div>
              <div class="ai-suggestion__body">
              <div v-if="cargandoAdeudos" class="body-2 grey--text">Buscando adeudos…</div>
              <div v-else-if="!alumnos.length" class="body-2">
                Este ticket no trae alumno. No se puede eliminar el adeudo desde aquí.
              </div>
              <div v-else-if="!adeudosTicket.length" class="body-2">
                No hay adeudo registrado para este alumno.
              </div>
              <div v-else>
                <div
                  v-for="item in adeudosTicket"
                  :key="claveAdeudo(item)"
                  class="mb-3"
                >
                  <div class="d-flex align-start flex-wrap">
                  <v-checkbox
                    v-model="adeudosSeleccionados"
                    :value="claveAdeudo(item)"
                    :disabled="!!(item.puntos && item.puntos.length && !item.listo)"
                    hide-details
                    dense
                    class="mt-0 mr-2"
                    style="flex: 1 1 240px"
                  >
                    <template v-slot:label>
                      <span class="body-2">
                        <strong>Adeudo {{ formatMoney(item.adeudo) }}</strong>
                        · Pagó {{ formatMoney(item.pagado) }}
                        · {{ item.nombre }}
                        <span class="grey--text d-block">{{ item.grupo }}</span>
                      </span>
                    </template>
                  </v-checkbox>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="primary"
                        class="mt-1"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="verHistorialPagos(item)"
                      >
                        <v-icon small>mdi-history</v-icon>
                      </v-btn>
                    </template>
                    <span>Historial de pagos</span>
                  </v-tooltip>
                  </div>
                  <div v-if="item.puntos && item.puntos.length" class="ml-8 mt-1">
                    <div
                      v-for="(punto, n) in item.puntos"
                      :key="claveAdeudo(item) + '-' + n"
                      class="d-flex align-start mb-1"
                    >
                      <v-icon small class="mr-2" :color="punto.cumple ? 'success' : 'error'">
                        {{ punto.cumple ? 'mdi-check-circle' : 'mdi-close-circle' }}
                      </v-icon>
                      <div class="body-2">
                        <div>{{ punto.texto }}</div>
                        <div v-if="punto.detalle" class="grey--text">{{ punto.detalle }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <v-btn
                  class="mt-3 text-none"
                  color="deep-purple darken-2"
                  small
                  dark
                  :disabled="!adeudosListosParaEliminar() || eliminandoAdeudo"
                  :loading="eliminandoAdeudo"
                  @click="eliminarAdeudosYResponder"
                >
                  Eliminar y responder
                </v-btn>
              </div>
              </div>
            </v-sheet>
            <div v-if="alumnos.length && i==0" class="mt-4">
              <label class="black--text"><b>Alumnos</b></label>
              <v-data-table
                :headers="headersAlumnos"
                :items="alumnos"
                class="elevation-0 mt-4 mb-4 ticket-etiquetas"
                :mobile-breakpoint="100"
                dense
                hide-default-footer
              >
              </v-data-table>
            </div>
            <ResumenIaTicket v-if="i==0" :idticket="ticket.idticket" :auto="[1, 2].includes(Number(ticket.estatus))" />
            <mensajeIzq :respuestas="respuestas" :ticket="ticket"></mensajeIzq>
            <mensajeDer :respuestas="respuestas" :ticket="ticket"></mensajeDer>
            <br v-if="respuestas.estatus==0">
            <v-divider v-if="respuestas.estatus==0"></v-divider>
            <v-alert
              v-if="mostrarPreRespuestaIa && respuestas.estatus==0 && preRespuestaIaActiva"
              dense
              colored-border
              border="left"
              color="deep-purple"
              class="mt-3 mb-0"
            >
              Pre-respuesta del Agente IA cargada en Solución. Puedes editarla antes de enviar.
            </v-alert>
            <v-textarea class="mt-4" v-if="respuestas.estatus==0" rows="5" outlined v-model="respuesta" label="Solución"></v-textarea>
            <v-file-input
              v-if="respuestas.estatus==0"
              small-chips
              multiple
              filled
              dense
              single-line
              v-model="files"
              accept="image/png, image/jpeg, image/bmp, video/mp4, video/x-m4v, video/*, application/pdf, .pdf"
              placeholder="Imágenes, videos o PDF"
              prepend-icon="mdi-camera"
              label="Evidencias"
              @change="cargarFotos()"
            ></v-file-input>

            <v-row class="mb-4" v-if="respuestas.estatus==0">
              <v-col cols="2" v-for="(img, i) in vistaPrevias" :key="i">
                <v-card class="py-4 shadowCard">
                  <EvidenciaMini :src="img.url" :video="!!img.video" :pdf="!!img.pdf" :nombre="img.image_name" />
                  <v-btn color="error" x-small @click="eliminarFoto(img.url)" top right absolute fab>
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
            <div
              v-if="respuestas.estatus==0 && i == ( historial.length - 1 )"
              class="pb-2 d-flex flex-wrap"
              style="gap: 6px"
            >
              <v-tooltip
                v-for="item in botonesReasignacionDepartamentos"
                :key="'resp-' + item.iddepartamento"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :color="item.color"
                    dark
                    x-small
                    @click="confirmarReasignarDepartamento(item)"
                  >
                    {{ item.abreviatura }}
                  </v-btn>
                </template>
                <span>reasignar</span>
              </v-tooltip>
            </div>
          </v-container>
          <InfoAlumnoTicket
            v-if="i == ( historial.length - 1 )"
            :mostrar="esTicketAlumno"
            :cargando="cargandoInfoAlumno"
            :info="infoAlumno"
            :error="errorInfoAlumno"
          />
          <v-card-actions  class="pa-0 pb-2 d-flex flex-wrap" v-if="i == ( historial.length - 1 )">
            <v-btn color="blue"   dark small @click="cargarNotas()">Ver notas {{ mensajes.length }}</v-btn>
            <v-btn color="blue"   dark small @click="dialogHistorialReasignacion = true"><v-icon>mdi-file-document</v-icon> {{ historialAsignacion.length }}</v-btn>
            <!-- Info alumno: ahora se anexa al motivo al crear el ticket (API addTicket)
            <v-btn
              v-if="esTicketAlumno"
              color="teal"
              dark
              small
              :loading="cargandoInfoAlumno"
              @click="verInfoAlumno()"
            >
              Ver información
            </v-btn>
            -->
            <v-spacer></v-spacer>
            <v-btn small color="success darken-1" @click="saveRespuestaAdmin(respuestas)">
              Responder
            </v-btn>
          </v-card-actions>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogHistorialPagos" max-width="1100px">
      <v-card>
        <v-card-title class="pb-0">
          <span class="text-subtitle-1">
            {{ alumnoHistorialPagos && alumnoHistorialPagos.alumno ? alumnoHistorialPagos.alumno : 'Historial de pagos' }}
          </span>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogHistorialPagos = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          <GruposAlumno
            v-if="dialogHistorialPagos && alumnoHistorialPagos"
            :editedItem="alumnoHistorialPagos"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Aceptar respuesta auxiliar -->
    <v-dialog v-model="dialogRespuestaAuxi" max-width="600px" @keydown.ctrl="pegar">
      <v-card>
        <v-card-title>
          <span class="headline">Responder al usuario</span>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogRespuestaAuxi=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <ResumenIaTicket :idticket="ticket.idticket" :auto="[1, 2].includes(Number(ticket.estatus))" />
          <v-container class="pt-0">
            <div class="d-flex flex-wrap align-center ticket-etiquetas" style="gap: 8px">
              <v-chip small color="deep-purple" outlined>
                {{ ticket.motivo_concepto || 'Sin etiqueta' }}
              </v-chip>
              <v-chip
                v-if="ticket.servicio_requerido"
                small
                dark
                :color="colorServicio(ticket.servicio_requerido)"
              >{{ ticket.servicio_requerido }}</v-chip>
              <v-chip v-else small outlined>Sin servicio</v-chip>
            </div>
            <div v-if="alumnos.length" class="mt-4">
              <label class="black--text"><b>Alumnos</b></label>
              <v-data-table
                :headers="headersAlumnos"
                :items="alumnos"
                class="elevation-0 mt-4 mb-4 ticket-etiquetas"
                :mobile-breakpoint="100"
                dense
                hide-default-footer
              >
              </v-data-table>
            </div>
            <mensajeIzq class="mt-6" :respuestas="lastHistorial" :ticket="ticket"></mensajeIzq>
            <mensajeDerAux :respuestas="lastHistorial" :ticket="ticket"></mensajeDerAux>
            <InfoAlumnoTicket
              :mostrar="esTicketAlumno"
              :cargando="cargandoInfoAlumno"
              :info="infoAlumno"
              :error="errorInfoAlumno"
            />
            <br>
            <v-divider></v-divider>
            <v-row class="mt-4">
              <v-textarea
                rows="3"
                outlined
                v-model="miRespuesta"
                label="Respuesta para el usuario"
                hide-details
                auto-grow
              ></v-textarea>
            </v-row>
            <v-file-input  class="mt-4"
              small-chips
              multiple
              filled
              dense
              single-line
              v-model="files"
              accept="image/png, image/jpeg, image/bmp, video/mp4, video/x-m4v, video/*, application/pdf, .pdf"
              placeholder="Imágenes, videos o PDF"
              prepend-icon="mdi-camera"
              label="Evidencias"
              @change="cargarFotos()"
            ></v-file-input>

            <v-row class="mb-4">
              <v-col cols="2" v-for="(img, i) in vistaPrevias" :key="i">
                <v-card class="py-4 shadowCard">
                  <EvidenciaMini :src="img.url" :video="!!img.video" :pdf="!!img.pdf" :nombre="img.image_name" />
                  <v-btn color="error" x-small @click="eliminarFoto(img.url)" top right absolute fab>
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
            <div class="pb-2 d-flex flex-wrap" style="gap: 6px">
              <v-tooltip
                v-for="item in botonesReasignacionDepartamentos"
                :key="'auxi-' + item.iddepartamento"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :color="item.color"
                    dark
                    x-small
                    @click="confirmarReasignarDepartamento(item)"
                  >
                    {{ item.abreviatura }}
                  </v-btn>
                </template>
                <span>reasignar</span>
              </v-tooltip>
            </div>
          </v-container>
          <v-card-actions class="pa-0 d-flex flex-wrap">
            <v-btn color="blue"   dark small @click="cargarNotas()">Ver notas {{ mensajes.length }}</v-btn>
            <v-btn color="blue"   dark small @click="dialogHistorialReasignacion = true"><v-icon>mdi-file-document</v-icon> {{ historialAsignacion.length }}</v-btn>
            <v-btn color="blue" dark small @click="dialogAceptar = true">Regresar al Auxiliar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="responderTicket()">
              Responder
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Info alumno (solo tickets tipousuario=1) — deshabilitado: info va en el motivo al crear
    <v-dialog v-model="dialogInfoAlumno" max-width="480px">
      <v-card>
        <v-card-title class="headline">
          Información del alumno
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogInfoAlumno = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text v-if="infoAlumno">
          <div class="mb-2"><b>Alumno:</b> {{ infoAlumno.alumno || '—' }}</div>
          <div class="mb-2"><b>Matrícula:</b> {{ infoAlumno.matricula || '—' }}</div>
          <div class="mb-2"><b>Ciclo actual:</b> {{ (infoAlumno.ciclo_actual && infoAlumno.ciclo_actual.ciclo) || 'Sin grupo en ciclo vigente' }}</div>
          <div class="mb-2"><b>Grupo:</b> {{ (infoAlumno.ciclo_actual && infoAlumno.ciclo_actual.grupo) || '—' }}</div>
          <v-alert
            v-if="infoAlumno.grupos_ciclo_actual && infoAlumno.grupos_ciclo_actual.length > 1"
            dense
            text
            type="info"
            class="mt-2 mb-0"
          >
            Tiene {{ infoAlumno.grupos_ciclo_actual.length }} grupos en el ciclo vigente.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text @click="dialogInfoAlumno = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    -->

    <!-- Contenido del ticket en solo lectura (ver y comentar) -->
    <v-dialog v-model="dialogContenidoTicket" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Ticket: {{ ticket.idticket }}</span>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogContenidoTicket = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex flex-wrap align-center mb-1" style="gap: 8px">
            <v-chip small color="deep-purple" outlined>{{ ticket.motivo_concepto || 'Sin etiqueta' }}</v-chip>
            <v-chip
              v-if="ticket.servicio_requerido"
              small
              dark
              :color="colorServicio(ticket.servicio_requerido)"
            >{{ ticket.servicio_requerido }}</v-chip>
          </div>
          <div class="body-2">
            Usuario: <strong>{{ ticket.nombre_completo }}</strong>
            · {{ ticket.puesto_usuario || 'Sin puesto' }}
            · {{ ticket.plantel }}
          </div>
          <div class="body-2">Encargado: <strong>{{ ticket.nombre_jefe || 'Sin encargado' }}</strong></div>
          <v-data-table
            v-if="alumnos.length"
            :headers="headersAlumnos"
            :items="alumnos"
            class="elevation-0 mt-3"
            :mobile-breakpoint="100"
            dense
            hide-default-footer
          ></v-data-table>
          <div v-for="(respuestas, i) in historial" :key="'contenido-' + i">
            <mensajeIzq class="mt-4" :respuestas="respuestas" :ticket="ticket"></mensajeIzq>
            <mensajeDer :respuestas="respuestas" :ticket="ticket"></mensajeDer>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue" dark small @click="cargarNotas()">Ver notas {{ mensajes.length }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogContenidoTicket = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogMensajes" hide-overlay persistent max-width="800">
      <v-card style="position: relative">
        <v-card-title primary-title>
          Agregar nota
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogMensajes = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <span v-for="(mensaje, i) in mensajes" :key="i">
            <v-row v-if="mensaje.id_usuario != getdatosUsuarioERPERP.iderp">
              <v-col cols="12">
                <v-card class="ml-6 pa-3 mt-2" max-width="400" color="#f2f2f2" style="border-radius: 15px; border-top-left-radius: 0">
                  <div class="text-subtitle-1">{{ mensaje.nota }} </div>
                  <v-card-actions class="pa-0">
                    <div class="text-caption blue--text">{{ mensaje.nombre_completo }}</div>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="mensaje.id_usuario == getdatosUsuarioERPERP.iderp">
              <v-col cols="12" align="right">
                <v-card class="mr-6 mt-2 pa-3" max-width="400" dark color="#0465ac" shaped style="border-radius: 15px; border-top-right-radius: 0;">
                  <div class="text-subtitle-1">{{ mensaje.nota }}</div>
                </v-card>
              </v-col>
            </v-row>
          </span>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogHistorialReasignacion" hide-overlay max-width="800">
      <v-card style="position: relative">
        <v-card-title primary-title>
          Historial Reasignacion
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogHistorialReasignacion = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersHistorialAsignacion"
            :items="historialAsignacion"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Selección de puesto y usuario (solo para Operaciones) -->
    <v-dialog v-model="dialogSeleccionOps" max-width="400px">
      <v-card class="pa-2">
        <v-card-title class="subtitle-1 font-weight-medium pb-1">
          Reasignar a Operaciones
        </v-card-title>
        <v-card-text class="pt-1 pb-2">
          <v-autocomplete
            outlined
            dense
            :items="opsPuestos"
            v-model="opsPuesto"
            label="Selecciona un puesto"
            return-object
            item-value="idpuesto"
            item-text="puesto"
            :item-disabled="isPuestoBloqueado"
          ></v-autocomplete>

          <v-autocomplete
            outlined
            dense
            hide-details
            :items="opsUsuarios"
            v-model="opsUsuario"
            label="Selecciona un usuario"
            return-object
            item-value="id_usuario"
            item-text="nombre_completo"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions class="px-4 pb-4 pt-0">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-1"
            @click="cancelarSeleccionOperaciones()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            depressed
            class="ml-2"
            @click="confirmarSeleccionOperaciones()"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmarReasignar" max-width="480px">
      <v-card class="pa-2">
        <v-card-title class="subtitle-1 font-weight-medium pb-1">
          Reasignar ticket
        </v-card-title>
        <v-card-text class="pt-1 pb-2">
          <div class="body-2 grey--text text--darken-2">
            ¿Estás seguro que deseas reasignar el ticket?
          </div>
          <div
            v-if="reasignacionPendiente && reasignacionPendiente.departamento"
            class="mt-3 pa-3"
            style="background:#f5f5f5; border-radius:8px"
          >
            <div class="caption grey--text mb-1">Destino</div>
            <div class="body-2 font-weight-medium">
              {{ reasignacionPendiente.departamento }}
            </div>
            <div
              v-if="reasignacionPendiente.puesto"
              class="caption grey--text text--darken-1 mt-1"
            >
              {{ getEtiquetaPuesto(reasignacionPendiente.puesto) }}
            </div>
            <div
              v-if="reasignacionPendiente.jefe"
              class="caption grey--text text--darken-1 mt-1"
            >
              {{ reasignacionPendiente.jefe.nombre_completo }}
            </div>
          </div>
          <v-textarea
            v-model="notaReasignacion"
            class="mt-3"
            outlined
            dense
            rows="3"
            auto-grow
            label="Nota *"
            placeholder="Escribe el motivo de la reasignación"
            hide-details="auto"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="px-4 pb-4 pt-0">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-1"
            @click="cancelarReasignarDepartamento()"
          >
            No
          </v-btn>
          <v-btn
            color="primary"
            depressed
            class="ml-2"
            :disabled="cargar || !(notaReasignacion && notaReasignacion.trim())"
            @click="aceptarReasignarDepartamento()"
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogReasignar" hide-overlay persistent max-width="480">
      <v-card style="position: relative">
        <v-card-title primary-title >
          Reasignar ticket
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogReasignar = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" >
              <v-autocomplete
                outlined
                dense
                :items="areas"
                v-model="area"
                label="Selecciona departamento"
                return-object
                item-value="iddepartamento"
                item-text="departamento"
              ></v-autocomplete>

              <v-autocomplete
                outlined
                dense
                :items="puestosReasignacion"
                v-model="puesto"
                label="Selecciona un puesto"
                return-object
                item-value="idpuesto"
                item-text="puesto"
                :item-disabled="isPuestoBloqueado"
              ></v-autocomplete>

              <v-autocomplete
                outlined
                dense
                :items="jefes"
                v-model="jefe"
                label="Selecciona un jefe"
                return-object
                item-value="id_usuario"
                item-text="nombre_completo"
              ></v-autocomplete>

              <v-textarea
                v-model="notaReasignacion"
                outlined
                dense
                rows="3"
                auto-grow
                label="Nota *"
                placeholder="Escribe el motivo de la reasignación"
                hide-details="auto"
              ></v-textarea>

            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="dialogReasignar = false">Cancelar</v-btn>
          <v-btn
            color="success"
            text
            :disabled="cargar || !(notaReasignacion && notaReasignacion.trim())"
            @click="reasignar()"
          >Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Visualizar imagenes -->
    <Imagen @close="closeImagen" :respuestaImagen="es_solucion" :isOpen="dialogImagen" :imagen="imagen" :ticket="ticket"/>

    <!-- Rechazar respuesta de Auxiliar-->
    <v-dialog v-model="dialogAceptar" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table">
                <div
                class="text-h6"
                style="display: table-cell; vertical-align: middle"
                >
                <strong>Aceptar:</strong> ¿Estás seguro que deseas cambiar el estatus a pendiente?
                <v-card-actions class="pt-6">
                  <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                  <v-btn
                  color="error"
                  text
                  large
                  class="mr-2"
                  @click="dialogAceptar=false"
                  >No, cancelar</v-btn
                  >
                  <!-- Guardar la información  -->
                  <v-btn
                  color="#5C5C5C"
                  dark
                  class="elevation-6"
                  large
                  @click="dialogAceptar = false, updateTicketEstatus()"
                  >Si</v-btn
                  >
                </v-card-actions>
              </div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-img src="@/assets/contrato.jpg"></v-img>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    </v-dialog>

    <!-- Visualizar historial -->
    <verTicket
      @close="closeModal"
      :isOpen="dialogHistorial"
      :historial="historial"
      :ticket="ticket"
      :infoAlumno="infoAlumno"
      :cargandoInfoAlumno="cargandoInfoAlumno"
      :errorInfoAlumno="errorInfoAlumno"
    ></verTicket>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
  import axios from 'axios';
  var moment = require('moment');
  moment.locale('es');

  import funcionesExcel  from '@/mixins/funcionesExcel'
  import {mapGetters, mapActions} from 'vuex'
  import { esJefeTickets, esVisorTicketsPuestos } from '@/utils/permisosTicketsValeria'

  // Se cambia por la contraseña real cuando el servidor la genera, al darle Responder.
  const MARCA_CONTRASENA = '(se genera al responder)'
  const MARCA_CAMBRIDGE = '(Los accesos Cambridge se asignan y se agregan al responder)'
  // Mismo patrón que PIDE_CODIGOS en api-rh/scripts/tickets/ticket_cambridge.js: sin esto no se consulta ni sale el esqueleto.
  // Si la IA no lo etiquetó como acceso: pide para sí mismo un cambio de sucursal, plataforma, KPI o CRM.
  // El servidor además exige el nombre de una sucursal real en el texto.
  const pideSucursalPropia = (texto) => {
    const t = String(texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
    return /\b(mi|me|\w+me)\b/.test(t) && /agreg|actualiz|cambi|habilit|acceso|anad|pon|pas|mov|asign/.test(t) &&
      /sucursal|plantel|plataforma|kpi|crm/.test(t)
  }
  const PIDE_CODIGOS_CAMBRIDGE =/candidate id|institution id|(habilit|gener)\w* (el |los |mis |su )?codigos?|(codigo|usuario|contrasena|password)[^.]*(examen|cambridge)|(examen|cambridge)[^.]*(codigo|usuario|contrasena|password)/

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
  import verTicket             from '@/components/tickets/verTicket.vue';
  import mensajeIzq            from '@/components/tickets/mensajeIzq.vue';
  import mensajeDer            from '@/components/tickets/mensajeDer.vue';
  import mensajeDerAux         from '@/components/tickets/mensajeDerAux.vue';
  import Imagen                from '@/components/tickets/Imagen.vue'
  import EvidenciaMini         from '@/components/tickets/EvidenciaMini.vue'
  import { clasificarArchivoEvidencia } from '@/utils/ticketEvidencias'
  import InfoAlumnoTicket      from '@/components/tickets/InfoAlumnoTicket.vue'
  import GruposAlumno          from '@/components/inscripciones/GruposAlumno.vue'
  import ResumenIaTicket       from '@/components/tickets/ResumenIaTicket.vue'

  import { Clipboard } from "@capacitor/clipboard";
  import { fetchInfoAlumno } from '@/utils/infoAlumnoTicketCache'
  /** Flag temporal: desactivar pre-respuesta IA en bandeja del jefe. */
  const HABILITAR_PRE_RESPUESTA_IA = false
  
  export default {

    components:{
      ResumenIaTicket,
      Alerta,
      carga,
      verTicket,
      mensajeIzq,
      mensajeDerAux,
      mensajeDer,
      Imagen,
      EvidenciaMini,
      InfoAlumnoTicket,
      GruposAlumno,
    },

    mixins: [ funcionesExcel ],

    data: () => ({
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      firstHistorial: {},
      lastHistorial: {},
      historial:{},
      ticket:{},

      tickets: [],
      totalTickets: 0,
      conteosApi: null,
      metricasTickets: {
        ticketMasViejoSinResponder: null,
        promedioRespuesta: {
          minutos: null,
          total_tickets: 0,
        },
      },
      tableOptions: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['fecha_apertura'],
        sortDesc: [true],
      },
      lastFetchKey: '',
      mensajes:[],

      respuestaAlerta:false,
      cargar: false,
      /** Carga de tabla sin modal (filtros, búsqueda, paginación). */
      cargandoTabla: false,
      historialAsignacion:[],

      dialogHistorial:false,
      dialogRespuesta: false,
      dialogRespuestaAuxi:false,
      dialogAsignarAux: false,
      dialogHistorialReasignacion: false,
      
      dialogAceptar: false,
      dialogReasignar:false,
      dialogConfirmarReasignar: false,
      reasignacionPendiente: null,
      dialogSeleccionOps: false,
      opsDepartamento: null,
      opsPuesto: null,
      opsUsuario: null,
      dialogMensajes:false,
      dialogError:false,
      ticketTieneResumenGuardado: false,
      resumenTicketTitulo: '',
      resumenTicketPedido: '',
      sugerenciaRespuestaTicket: '',
      preRespuestaIaActiva: false,

      search:'',
      respuesta:'',
      miRespuesta:'',
      mensajeRechazo:'',
      notaReasignacion: '',
      dialogContenidoTicket: false,
      soloMios: false,
      error:'',

    	auxiliares:[],
      auxiliar:{idauxi_area:0,nombre_completo:''},

      headers: [
        { text: 'Folio',       value: 'idticket',         },
        { text: 'Usuario',     value: 'nombre_completo'   },
        { text: 'Puesto',      value: 'puesto_usuario'    },
        { text: 'Sucursal',    value: 'plantel'           },
        { text: 'F. creación', value: 'fecha_apertura'    },
        { text: 'Estatus',     value: 'estatus'           },
        { text: 'Encargado',   value: 'nombre_jefe'       },
        { text: 'Auxiliar',    value: 'nombre_auxiliar'   },
        { text: 'Motivo',      value: 'motivo_concepto'   },
        { text: 'Servicio requerido', value: 'servicio_requerido' },
        { text: 'Actions',     value: 'actions', sortable: false },
        { text: 'Responder',   value: 'ver'               },
        { text: 'Historial',   value: 'historial', sortable: false },
      ],

      headersHistorialAsignacion: [
        { text: 'ID',                   value: 'idhistorial_ticket_reasignacion'},
        { text: 'Fecha',                value: 'fecha_reasignacion'             },
        { text: 'Departamento Origen',  value: 'area_viejo'                     },
        { text: 'Usuario',              value: 'usuario_viejo'                  },
        { text: 'Departamento Destino', value: 'area_nuevo'                     },
        { text: 'Usuario',              value: 'usuario_nuevo'                  },
      ],

      headersAlumnos:[
        { text: 'matricula', value: "matricula" },
        { text: 'alumno'   , value: "alumno" },
        { text: 'grupo'    , value: "grupo" },
      ],
      
      areas:[],
      area: null,

      puestos:[],
      puesto:null,

      jefes:[],
      jefe: null,

      estatusFiltro:2,
      filtroMotivo: '__todos__',
      motivosApi: [],
      filtroPuesto: '__todos__',
      puestosApi: [],

      fechaFiltroDesde: '',
      fechaFiltroHasta: '',
      clasificacionFiltro: null,
      filtroEncargado: null,
      opcionesEncargado: [],

      chipsEstatusOpciones: [
        { value: 8, label: 'Todos', color: 'grey' ,icon: 'mdi-filter-off' },
        { value: 9, label: 'Por contestar', color: 'deep-purple', icon: 'mdi-message-reply-text-outline' },
        // { value: 1, label: 'Abierto', color: 'orange' ,icon: 'mdi-folder-open-outline' },
        { value: 2, label: 'Asignado', color: 'blue' ,icon: 'mdi-account-arrow-right' },
        { value: 3, label: 'Pendiente', color: 'red' ,icon: 'mdi-clock-alert-outline' },
        { value: 4, label: 'Revisión', color: 'grey' ,icon: 'mdi-eye-outline' },
        { value: 5, label: 'Respondido', color: 'green' ,icon: 'mdi-check-circle-outline' },
        { value: 6, label: 'Cerrado', color: 'yellow' ,icon: 'mdi-lock-outline' },
        { value: 7, label: 'Rechazado', color: 'black' ,icon: 'mdi-close-circle-outline' },
      ],

      url:'',
      urlINBI:'',
      urlFAST:'',

      escuela:0,
      urgente:0,

      dialogImagen:false,
      imagen: '',
      es_solucion:false,
      vistaPrevias: [],
      fotos:[],
      files: [],
      alumnos: [],
      adeudosTicket: [],
      adeudosSeleccionados: [],
      cargandoAdeudos: false,
      eliminandoAdeudo: false,
      relojPropuesta: null,
      relojTrabajador: null,
      relojPorAplicar: null,
      relojRechazoAuto: '',
      cargandoReloj: false,
      aplicandoReloj: false,
      grupoPropuesta: null,
      grupoElegido: null,
      grupoPorAplicar: null,
      cargandoGrupo: false,
      alumnoPropuesta: null,
      alumnoPorAplicar: null,
      cargandoAlumno: false,
      sucursalPropuesta: null,
      sucursalElegida: null,
      sucursalPorAplicar: null,
      contrasenaPropuesta: null,
      contrasenaPersona: null,
      contrasenaPorAplicar: null,
      revisandoAcceso: 0,
      vendedoraPropuesta: null,
      vendedoraElegida: null,
      vendedoraPorAplicar: null,
      cambridgePropuesta: null,
      cambridgePorAplicar: null,
      aplicandoGrupo: false,
      dialogHistorialPagos: false,
      alumnoHistorialPagos: null,
      cargandoInfoAlumno: false,
      infoAlumno: null,
      errorInfoAlumno: '',
    }),

    computed: {
      ...mapGetters('login',['getdatosUsuarioERPERP']),

      verTicketsJefe () {
        return esJefeTickets(this.getdatosUsuarioERPERP)
      },

      esVisorPuestos () {
        return esVisorTicketsPuestos(this.getdatosUsuarioERPERP)
      },

      opcionesMotivo () {
        const filas = this.motivosApi || []
        let sinEtiqueta = 0
        let total = 0
        const etiquetas = []
        for (let i = 0; i < filas.length; i++) {
          const n = Number(filas[i].n) || 0
          total += n
          if (!filas[i].etiqueta) {
            sinEtiqueta += n
          } else {
            etiquetas.push({ text: filas[i].etiqueta + ' (' + n + ')', value: filas[i].etiqueta, cantidad: n })
          }
        }
        etiquetas.sort(function (a, b) {
          if (b.cantidad !== a.cantidad) return b.cantidad - a.cantidad
          return String(a.value).localeCompare(String(b.value), 'es')
        })
        const opciones = [{ text: 'Todos (' + total + ')', value: '__todos__' }]
        if (sinEtiqueta) {
          opciones.push({ text: 'Sin etiqueta (' + sinEtiqueta + ')', value: '__sin__' })
        }
        return opciones.concat(etiquetas)
      },

      opcionesPuesto () {
        const filas = this.puestosApi || []
        let total = 0
        const opciones = []
        for (let i = 0; i < filas.length; i++) {
          const n = Number(filas[i].n) || 0
          total += n
          const puesto = filas[i].puesto ? String(filas[i].puesto) : ''
          opciones.push({
            text: (puesto || 'Sin puesto') + ' (' + n + ')',
            value: puesto || '__sin__',
            cantidad: n,
          })
        }
        opciones.sort(function (a, b) {
          if (b.cantidad !== a.cantidad) return b.cantidad - a.cantidad
          return String(a.text).localeCompare(String(b.text), 'es')
        })
        return [{ text: 'Todos (' + total + ')', value: '__todos__' }].concat(opciones)
      },

      esTicketAlumno () {
        return Number(this.ticket && this.ticket.tipousuario) === 1
      },

      esEliminacionAdeudo () {
        const etiqueta = String((this.ticket && this.ticket.motivo_concepto) || '').trim()
        if (etiqueta === 'Eliminación de adeudo') return true
        return this.textoPideEliminarAdeudo()
      },

      esAjusteReloj () {
        return String((this.ticket && this.ticket.motivo_concepto) || '').trim() === 'Ajuste de reloj'
      },

      puedeCorregirReloj () {
        const id = Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp)
        return this.esAjusteReloj && (id === 1 || id === 334 || id === 966)
      },

      esAperturaGrupo () {
        return String((this.ticket && this.ticket.motivo_concepto) || '').trim() === 'Apertura de grupo'
      },

      // Botones automáticos: por ahora solo desarrollador (11) y jefe de TI (12). El servidor revisa lo mismo.
      puedeBotonesTicket () {
        return [11, 12].includes(Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto))
      },

      puedeCorregirAlumno () {
        return this.puedeBotonesTicket && String((this.ticket && this.ticket.motivo_concepto) || '').trim() === 'Corrección datos alumno'
      },

      puedeAbrirGrupo () {
        const id = Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp)
        return this.esAperturaGrupo && (id === 334 || id === 568)
      },

      puedeSeleccionarAuxiliarRH () {
        return Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp) === 966
      },

      puestosReasignacion () {
        return this.filtrarPuestosPermitidos(this.puestos)
      },

      /** Puestos del departamento de Operaciones para el selector del botón OPS. */
      opsPuestos () {
        const puestos = (this.opsDepartamento && this.opsDepartamento.puestos) || []
        return this.filtrarPuestosPermitidos(puestos)
          .filter((p) => Array.isArray(p.jefes) && p.jefes.length)
      },

      opsUsuarios () {
        return (this.opsPuesto && this.opsPuesto.jefes) || []
      },

      /** Un botón por departamento → su jefe de área (p. ej. Operaciones → 568). */
      botonesReasignacionDepartamentos () {
        return (this.areas || [])
          .map((depto) => this.resolverJefeAreaDepartamento(depto))
          .filter((item) => item && item.jefe && item.puesto)
          .map((item) => {
            const estilo = this.estiloBotonDepartamento(item.departamento)
            return {
              ...item,
              abreviatura: estilo.abreviatura,
              color: estilo.color,
            }
          })
      },

      formTitle () {
        return this.editedIndex === -1 ? 'Agregar ticket' : 'Responder Ticket'
      },

      mostrarPreRespuestaIa () {
        return HABILITAR_PRE_RESPUESTA_IA
      },

      /** Conteos de chips (servidor, mismos filtros que la tabla excepto estatus/clasificación según chip). */
      conteosEstatus () {
        if (this.conteosApi && this.conteosApi.estatus) {
          return this.conteosApi.estatus
        }
        return { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0 }
      },

      ticketMasViejoSinResponder () {
        return this.metricasTickets && this.metricasTickets.ticketMasViejoSinResponder
          ? this.metricasTickets.ticketMasViejoSinResponder
          : null
      },

      ticketMasViejoTiempoTexto () {
        return this.formatearDuracionMinutos(
          this.ticketMasViejoSinResponder
            ? this.ticketMasViejoSinResponder.minutos_sin_responder
            : null
        )
      },

      promedioRespuestaTexto () {
        const promedio = this.metricasTickets && this.metricasTickets.promedioRespuesta
          ? this.metricasTickets.promedioRespuesta
          : {}
        return this.formatearDuracionMinutos(promedio.minutos)
      },
    },

    watch: {
      area(){
        const puestosArea = (this.area && this.area.puestos) ? this.area.puestos : []
        this.puestos = this.filtrarPuestosPermitidos(puestosArea)
        if (this.puesto && this.isPuestoBloqueado(this.puesto)) {
          this.puesto = null
          this.jefes = []
          this.jefe = null
        }
      },

      puesto(){
        this.jefes = this.puesto ? this.puesto.jefes : []
      },

      opsPuesto(){
        this.opsUsuario = null
      },

      estatusFiltro () {
        this.recargarTicketsPorFiltroDebounced()
      },
      fechaFiltroDesde () {
        this.recargarTicketsPorFiltroDebounced()
      },
      fechaFiltroHasta () {
        this.recargarTicketsPorFiltroDebounced()
      },
      filtroEncargado () {
        this.recargarTicketsPorFiltroDebounced()
      },
      filtroMotivo () {
        this.recargarTicketsPorFiltroDebounced()
      },
      filtroPuesto () {
        this.recargarTicketsPorFiltroDebounced()
      },
      soloMios () {
        this.recargarTicketsPorFiltroDebounced()
      },
      escuela () {
        this.recargarTicketsPorFiltroDebounced()
      },
      urgente () {
        this.recargarTicketsPorFiltroDebounced()
      },
      search () {
        if (this._searchDebounce) {
          clearTimeout(this._searchDebounce)
        }
        this._searchDebounce = setTimeout(() => {
          this.recargarTicketsPorFiltro()
        }, 400)
      },
    },

    async created () {
      this.url = axios.defaults.baseURL + 'evidencia-tickets/'
      this.urlINBI = 'https://lmsinbi.club/evidencia-tickets/'
      this.urlFAST = 'https://lmsfast.club/evidencia-tickets/'

      this.cargar = true
      try {
        await Promise.all([this.getAreas(), this.getAuxiliares()])
        await this.initialize()
      } finally {
        this.cargar = false
      }
    },

    beforeDestroy () {
      if (this._filtrosRecargaTimer) {
        clearTimeout(this._filtrosRecargaTimer)
        this._filtrosRecargaTimer = null
      }
      if (this._searchDebounce) {
        clearTimeout(this._searchDebounce)
      }
      if (this._dataTableOptsTimer) {
        clearTimeout(this._dataTableOptsTimer)
      }
    },

    methods: {
      metricasTicketsDefault () {
        return {
          ticketMasViejoSinResponder: null,
          promedioRespuesta: {
            minutos: null,
            total_tickets: 0,
          },
        }
      },

      formatearDuracionMinutos (value) {
        const totalMinutos = Math.round(Number(value))
        if (!Number.isFinite(totalMinutos) || totalMinutos < 0) return 'Sin datos'
        if (totalMinutos < 1) return 'Menos de 1 min'

        const dias = Math.floor(totalMinutos / 1440)
        const horas = Math.floor((totalMinutos % 1440) / 60)
        const minutos = totalMinutos % 60
        const partes = []

        if (dias) partes.push(`${dias} ${dias === 1 ? 'día' : 'días'}`)
        if (horas) partes.push(`${horas} h`)
        if (!dias && minutos) partes.push(`${minutos} min`)

        return partes.slice(0, 2).join(' ')
      },

      colorServicio (texto) {
        const t = String(texto || '').toLowerCase()
        if (t.indexOf('electric') !== -1) return 'amber darken-2'
        if (t.indexOf('plomer') !== -1) return 'blue'
        if (t.indexOf('aire') !== -1 || t.indexOf('clima') !== -1) return 'cyan darken-2'
        if (t.indexOf('pintur') !== -1) return 'purple'
        if (t.indexOf('cerraj') !== -1) return 'brown'
        if (t.indexOf('carpint') !== -1) return 'deep-orange'
        if (t.indexOf('limpie') !== -1) return 'teal'
        if (t.indexOf('herrer') !== -1) return 'blue-grey'
        if (t.indexOf('vidri') !== -1) return 'light-blue darken-3'
        if (t.indexOf('jardin') !== -1) return 'green darken-1'
        if (t.indexOf('alba') !== -1) return 'grey darken-1'
        if (t.indexOf('fumig') !== -1) return 'lime darken-3'
        if (t.indexOf('equipo') !== -1) return 'indigo'
        return 'orange darken-2'
      },

      normalizarTexto (value) {
        return (value || '')
          .toString()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .replace(/\s+/g, ' ')
          .trim()
      },

      getEtiquetaPuesto (puesto) {
        return typeof puesto === 'string'
          ? puesto
          : ((puesto && puesto.puesto) || '')
      },

      esAuxiliarRH (puesto) {
        const nombrePuesto = this.normalizarTexto(this.getEtiquetaPuesto(puesto))
        if (/auxiliar.*recursos humanos/.test(nombrePuesto)) return true

        const puestoComoJson = this.normalizarTexto(JSON.stringify(puesto || {}))
        return puestoComoJson.includes('auxiliar') && puestoComoJson.includes('recursos humanos')
      },

      isPuestoBloqueado (puesto) {
        return !this.puedeSeleccionarAuxiliarRH && this.esAuxiliarRH(puesto)
      },

      filtrarPuestosPermitidos (puestos) {
        const lista = Array.isArray(puestos) ? puestos : []
        if (this.puedeSeleccionarAuxiliarRH) return lista
        return lista.filter((puesto) => !this.esAuxiliarRH(puesto))
      },

      buildTicketsQueryParams (sinPaginar = false) {
        const o = this.tableOptions || {}
        const sortBy = (Array.isArray(o.sortBy) && o.sortBy.length) ? String(o.sortBy[0]) : 'fecha_apertura'
        const sortDesc = (Array.isArray(o.sortDesc) && o.sortDesc.length) ? !!o.sortDesc[0] : true
        const clas =
          this.clasificacionFiltro === null || this.clasificacionFiltro === ''
            ? ''
            : this.clasificacionFiltro === 'ignorar'
              ? 'ignorar'
              : String(this.clasificacionFiltro)
        const filtros = {
          sinEvidencias: 1,
          fechaDesde: this.fechaFiltroDesde || '',
          fechaHasta: this.fechaFiltroHasta || '',
          estatus: this.estatusFiltro,
          clasificacion: clas,
          q: (this.search || '').trim(),
        }
        if (this.escuela) filtros.escuela = String(this.escuela)
        if (this.urgente) filtros.urgente = String(this.urgente)
          if (this.filtroEncargado) filtros.idEncargado = String(this.filtroEncargado)
          if (this.filtroMotivo && this.filtroMotivo !== '__todos__') filtros.motivo = this.filtroMotivo
          if (this.filtroPuesto && this.filtroPuesto !== '__todos__') filtros.puesto = this.filtroPuesto
        if (this.esVisorPuestos && this.soloMios) filtros.soloMios = 1
        if (sinPaginar) {
          return { ...filtros, sinPaginar: 1 }
        }
        return {
          ...filtros,
          paginado: 1,
          page: o.page || 1,
          perPage: o.itemsPerPage || 50,
          sortBy,
          sortDesc: sortDesc ? 1 : 0,
        }
      },

      aplicarFormatoFechasFilas (rows) {
        if (!rows || !rows.length) return
        const fmt = new Intl.DateTimeFormat('es', {
          dateStyle: 'medium',
          timeStyle: 'short',
        })
        for (let i = 0; i < rows.length; i++) {
          const row = rows[i]
          try {
            row.fecha_apertura_correccion = row.fecha_apertura
              ? fmt.format(new Date(row.fecha_apertura))
              : ''
          } catch (e) {
            row.fecha_apertura_correccion = row.fecha_apertura
              ? moment(row.fecha_apertura).format('ll, h:mm a')
              : ''
          }
        }
      },

      mapEncargadosDesdeTickets (rows) {
        const mapa = new Map()
        ;(rows || []).forEach((t) => {
          const id = Number(t.idjefe_area)
          if (!id || mapa.has(id)) return
          mapa.set(id, {
            id,
            nombre: t.nombre_jefe || `ID ${id}`,
          })
        })
        return Array.from(mapa.values()).sort((a, b) =>
          String(a.nombre).localeCompare(String(b.nombre), 'es')
        )
      },

      recargarTicketsPorFiltro () {
        if (!this.verTicketsJefe) return
        this.tableOptions = { ...this.tableOptions, page: 1 }
        this.lastFetchKey = ''
        this.obtenerTickets(true, false)
      },

      /** Evita dos peticiones seguidas al tocar estatus y clasificación; la recarga va sin modal (solo tabla). */
      recargarTicketsPorFiltroDebounced () {
        if (this._filtrosRecargaTimer) {
          clearTimeout(this._filtrosRecargaTimer)
        }
        this._filtrosRecargaTimer = setTimeout(() => {
          this._filtrosRecargaTimer = null
          this.recargarTicketsPorFiltro()
        }, 100)
      },

      onDataTableOptions (opts) {
        if (!opts || !this.verTicketsJefe) return
        if (this._dataTableOptsTimer) {
          clearTimeout(this._dataTableOptsTimer)
        }
        this._dataTableOptsTimer = setTimeout(() => {
          const allowed = [25, 50, 100, 150]
          let ipp = opts.itemsPerPage || 50
          if (!allowed.includes(ipp)) ipp = 50
          this.tableOptions = { ...this.tableOptions, ...opts, itemsPerPage: ipp }
          this.obtenerTickets(false, false)
        }, 100)
      },

      refrescarTickets () {
        this.lastFetchKey = ''
        return this.obtenerTickets(true, true)
      },

      /** @param {boolean} useWaitModal — Si false, solo barra de tabla (chips de filtro, búsqueda, paginación). */
      initialize (useWaitModal = true) {
        this.lastFetchKey = ''
        return this.obtenerTickets(true, useWaitModal)
      },

      /**
       * @param {boolean} force
       * @param {boolean} useWaitModal — true: modal «Espera por favor»; false: solo indicador en la tabla.
       */
      obtenerTickets (force = false, useWaitModal = true) {
        if (!this.verTicketsJefe) {
          this.cargar = false
          this.cargandoTabla = false
          return Promise.resolve()
        }
        const params = this.buildTicketsQueryParams(false)
        const key = JSON.stringify(params)
        if (!force && key === this.lastFetchKey) {
          this.$nextTick(() => {
            if (useWaitModal) this.cargar = false
            else this.cargandoTabla = false
          })
          return Promise.resolve()
        }

        if (useWaitModal) {
          this.cargar = true
        } else {
          this.cargandoTabla = true
        }
        this.lastFetchKey = key

        return this.$http
          .get('tickets.area/' + this.getdatosUsuarioERPERP.iderp, { params })
          .then((response) => {
            const body = response.data
            let rows = []
            if (body && Array.isArray(body.rows)) {
              this.totalTickets = Number(body.total) || 0
              this.conteosApi = body.conteos || null
              this.metricasTickets = body.metricas || this.metricasTicketsDefault()
              if (Array.isArray(body.encargados)) {
                this.opcionesEncargado = body.encargados
              }
              this.motivosApi = Array.isArray(body.motivos) ? body.motivos : []
              this.puestosApi = Array.isArray(body.puestos) ? body.puestos : []
              rows = body.rows
            } else if (Array.isArray(body)) {
              this.totalTickets = body.length
              this.conteosApi = null
              this.metricasTickets = this.metricasTicketsDefault()
              rows = body
              this.opcionesEncargado = this.mapEncargadosDesdeTickets(rows)
            } else {
              this.totalTickets = 0
              this.conteosApi = null
              this.metricasTickets = this.metricasTicketsDefault()
              rows = []
            }
            this.aplicarFormatoFechasFilas(rows)
            this.tickets = rows
            this.$emit('recalcular')
          })
          .catch((error) => {
            const msg =
              error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : error.message || error
            this.validarError(msg)
          })
          .finally(() => {
            this.$nextTick(() => {
              if (useWaitModal) this.cargar = false
              else this.cargandoTabla = false
            })
          })
      },
      getAreas () {
        return this.$http.get('departamentos.tickets').then(response => {
          this.areas = response.data
        }).catch(error => {
          this.validarError(error.response.data.message)
        })
      },
      getAuxiliares () {
        this.auxiliares = []
        const permiso = this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.permiso
        const idArea = permiso && permiso.idareas_ticket
        if (!idArea) return Promise.resolve()
        return this.$http.get('auxiliares.porarea/'+idArea).then(response=>{
          this.auxiliares = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { })
      },

      closeModal(){
        this.dialogHistorial = false
      },

      //dialogo AsignarAux
      verMotivo(value){
      	this.ticket = value
        this.ticketTieneResumenGuardado = false
        this.cargarInfoAlumno()
        this.$http.get('historial_tickets.estatus/'+this.ticket.idticket).then((response) => {
          this.firstHistorial = response.data.HistorialTicket[0]
          this.lastHistorial = response.data.HistorialTicket[response.data.HistorialTicket.length - 1]
          this.mensajes = response.data.notas
          this.historialAsignacion = response.data.asignacion
          this.alumnos = response.data.alumnos
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { 
          this.dialogAsignarAux = true 
          this.cargar = false 
        })
        
      },

      verImagen( imagen, es_solucion ){
        this.imagen       = imagen
        this.es_solucion = es_solucion
        this.dialogImagen = true
      },
      closeImagen(){
        this.dialogImagen = false
      },

      save () {
      	this.ticket.idauxi_area = this.auxiliar.id_usuario
      	this.ticket.estatus = 4

        this.$http.put('tickets.update.asignacion.auxi/'+this.ticket.idticket, this.ticket).then(response=>{
        	
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { 
          this.validarSuccess('Ticket asignado a auxiliar')
          this.dialogAsignarAux = false
          this.cargar = false 
        })
      },

      verRespuestaAuxi(value){
        this.ticket = value
        this.historial = []
        this.respuesta = ''
        this.preRespuestaIaActiva = false
        this.sugerenciaRespuestaTicket = ''
        this.ticketTieneResumenGuardado = false
        this.cargarInfoAlumno()
        
        this.$http.get('historial_tickets.estatus/'+this.ticket.idticket).then(async (response) => {
          this.firstHistorial      = response.data.HistorialTicket[0]
          this.lastHistorial       = response.data.HistorialTicket[response.data.HistorialTicket.length - 1]
          this.mensajes            = response.data.notas
          this.alumnos             = response.data.alumnos
          this.historialAsignacion = response.data.asignacion
          await this.cargarPreRespuestaEnSolucion(response.data)
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { 
          this.dialogRespuestaAuxi = true
          this.cargar = false 
        })
      },

      responder(value){
        this.cargar = true
        this.ticket = value
        this.historial = []
        this.respuesta = ''
        this.preRespuestaIaActiva = false
        this.sugerenciaRespuestaTicket = ''
        this.resumenTicketTitulo = ''
        this.resumenTicketPedido = ''
        this.ticketTieneResumenGuardado = false
        this.adeudosTicket = []
        this.adeudosSeleccionados = []
        this.relojPropuesta = null
        this.relojTrabajador = null
        this.relojPorAplicar = null
        this.relojRechazoAuto = ''
        this.grupoPropuesta = null
        this.grupoElegido = null
        this.grupoPorAplicar = null
        this.alumnoPropuesta = null
        this.alumnoPorAplicar = null
        this.sucursalPropuesta = null
        this.sucursalElegida = null
        this.sucursalPorAplicar = null
        this.contrasenaPropuesta = null
        this.contrasenaPersona = null
        this.contrasenaPorAplicar = null
        this.vendedoraPropuesta = null
        this.vendedoraElegida = null
        this.vendedoraPorAplicar = null
        this.cambridgePropuesta = null
        this.cambridgePorAplicar = null
        this.cargarInfoAlumno()
        this.$http.get('historial_tickets.estatus/'+this.ticket.idticket).then(async (response)=>{
          for(const i in response.data.HistorialTicket){
            response.data.HistorialTicket[i].fecha = moment(response.data.HistorialTicket[i].fecha).format('MMMM Do YYYY, h:mm:ss a');
            response.data.HistorialTicket[i].fecharespuesta = moment(response.data.HistorialTicket[i].fecharespuesta).format('MMMM Do YYYY, h:mm:ss a');
            if(response.data.HistorialTicket[i].fecharespuesta == 'marzo 4º 2024, 3:31:27 pm'){
              response.data.HistorialTicket[i].fecharespuesta = ''
            }
            this.historial.push(response.data.HistorialTicket[i])
          }
          this.firstHistorial = response.data.HistorialTicket[0]
          this.lastHistorial = response.data.HistorialTicket[response.data.HistorialTicket.length - 1]
          this.mensajes = response.data.notas
          this.alumnos = response.data.alumnos
          this.historialAsignacion = response.data.asignacion
          this.ver = false
          this.cargarAdeudosTicket()
          await this.cargarRelojTicket()
          this.cargarGrupoTicket()
          this.cargarAlumnoTicket()
          this.cargarSucursalTicket()
          this.cargarContrasenaTicket()
          this.cargarVendedoraTicket()
          this.cargarCambridgeTicket()
          await this.cargarPreRespuestaEnSolucion(response.data)
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {
          this.dialogRespuesta = true 
          this.cargar = false
        })
      },

      /**
       * Rellena Solución con pre-respuesta IA leyendo el hilo completo.
       * El API regenera si el cache pide datos que ya están en el ticket.
       */
      async cargarPreRespuestaEnSolucion (historialPayload = {}) {
        try {
          if (!HABILITAR_PRE_RESPUESTA_IA) {
            this.preRespuestaIaActiva = false
            return
          }
          if (!this.ticket || !this.ticket.idticket) {
            this.preRespuestaIaActiva = false
            return
          }

          const postRes = await this.$http.post('tickets.prerespuesta.ia', {
            idticket: this.ticket.idticket,
          })
          let sug = String((postRes.data && postRes.data.sugerencia_respuesta) || '').trim()

          if (!sug) {
            sug = String(
              (historialPayload && historialPayload.sugerencia_respuesta) ||
                (historialPayload &&
                  historialPayload.asistencia_ia &&
                  historialPayload.asistencia_ia.sugerencia_respuesta) ||
                ''
            ).trim()
          }

          if (postRes.data) {
            this.resumenTicketTitulo = postRes.data.titulo || ''
            this.resumenTicketPedido = postRes.data.resumen_pedido || ''
          }

          if (sug) {
            this.sugerenciaRespuestaTicket = sug
            this.respuesta = sug
            this.miRespuesta = sug
            this.preRespuestaIaActiva = true
            this.ticketTieneResumenGuardado = true
          } else {
            this.preRespuestaIaActiva = false
          }
        } catch (e) {
          this.preRespuestaIaActiva = false
          console.warn('[pre-respuesta IA]', e)
        }
      },

      async responderTicket() {
        if(this.miRespuesta != ''){
          let fotos = []
          if(this.vistaPrevias.length){
            let respuesta = await this.subirFotosServidor( )
            fotos = respuesta.data
          }
          let payload = {
            idhistorial_ticket: this.lastHistorial.idhistorial_ticket,
            motivo: this.ticket.motivo,
            respuesta: this.miRespuesta,
            respuestaauxi: this.lastHistorial.respuestaauxi,
            idticket: this.ticket.idticket,
            estatus:0,
            id_usuario: this.ticket.id_usuario,
            folio: this.ticket.idticket,
            fotos,
            idauxi_area:        this.lastHistorial.idauxi_area,
            idjefe_area:        this.getdatosUsuarioERPERP.id_usuario
          }
          var estatus = {estatus: 5}
          this.$http.put('historial_tickets.update/'+this.lastHistorial.idhistorial_ticket, payload).then(response=>{
            this.$http.put('tickets.update.estatus/'+this.ticket.idticket,estatus).then(response=>{
              this.miRespuesta = ''
              this.dialogRespuestaAuxi = false
              this.vistaPrevias = []
              this.obtenerTickets(true, false)
            }).catch( error =>{
              this.validarError( error.response.data.message )
            }).finally( () => { this.cargar = false })
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        } else {
          this.validarErrorDirecto(' Respuesta vacia ')
        }
      },

      claveAdeudo (item) {
        return String(item.id_alumno) + '-' + String(item.id_grupo)
      },

      verHistorialPagos (item) {
        this.alumnoHistorialPagos = {
          id_alumno: item.id_alumno,
          alumno: item.nombre,
          matricula: item.matricula || '',
          email: '',
        }
        this.dialogHistorialPagos = true
      },

      formatMoney (valor) {
        const n = Number(valor)
        const monto = Number.isFinite(n) ? n : 0
        return '$' + monto.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      },

      textoPideEliminarAdeudo () {
        const partes = []
        if (this.ticket && this.ticket.motivo) partes.push(String(this.ticket.motivo))
        const lista = this.historial || []
        for (let i = 0; i < lista.length; i++) {
          if (lista[i] && lista[i].motivo) partes.push(String(lista[i].motivo))
        }
        const texto = partes.join(' ')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
        return /elimin\w*\s+(el |la |de |del )?adeudo|quitar(le)?\s+(el |ese )?adeudo/.test(texto)
      },

      cargarAdeudosTicket () {
        this.adeudosTicket = []
        this.adeudosSeleccionados = []
        if (!this.esEliminacionAdeudo) return Promise.resolve()
        const ids = []
        const gruposTicket = {}
        const lista = this.alumnos || []
        for (let i = 0; i < lista.length; i++) {
          const id = Number(lista[i].id_alumno)
          if (!id) continue
          if (ids.indexOf(id) === -1) ids.push(id)
          if (lista[i].id_grupo) gruposTicket[id + '-' + lista[i].id_grupo] = true
        }
        if (!ids.length) return Promise.resolve()
        this.cargandoAdeudos = true
        return this.$http.get('eliminacion-adeudos.por-alumnos', { params: { ids: ids.join(',') } }).then((response) => {
          const crudos = response.data || []
          const rows = []
          for (let i = 0; i < crudos.length; i++) {
            rows.push(this.conGrupoDelTicket(crudos[i], gruposTicket))
          }
          this.adeudosTicket = rows
          const seleccion = []
          for (let i = 0; i < rows.length; i++) {
            const clave = this.claveAdeudo(rows[i])
            const marcado = rows.length === 1 || gruposTicket[clave]
            const pasa = !rows[i].puntos || !rows[i].puntos.length || rows[i].listo
            if (marcado && pasa) seleccion.push(clave)
          }
          this.adeudosSeleccionados = seleccion
        }).catch((error) => {
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'No se pudieron consultar los adeudos.'
          this.validarError(msg)
        }).finally(() => {
          this.cargandoAdeudos = false
        })
      },

      conGrupoDelTicket (row, gruposTicket) {
        const item = Object.assign({}, row)
        const claves = Object.keys(gruposTicket || {})
        if (!claves.length || !item.puntos || !item.puntos.length) return item
        const coincide = !!gruposTicket[item.id_alumno + '-' + item.id_grupo]
        const puntos = item.puntos.slice()
        for (let i = 0; i < puntos.length; i++) {
          if (puntos[i].texto !== 'Ese alumno tiene adeudo en ese grupo') continue
          puntos[i] = {
            texto: puntos[i].texto,
            cumple: !!puntos[i].cumple && coincide,
            detalle: coincide ? puntos[i].detalle : 'El adeudo es de otro grupo',
          }
          break
        }
        item.puntos = puntos
        item.listo = puntos.every(function (punto) { return punto.cumple })
        return item
      },

      adeudosListosParaEliminar () {
        const elegidos = (this.adeudosTicket || []).filter((item) => {
          return this.adeudosSeleccionados.indexOf(this.claveAdeudo(item)) !== -1
        })
        if (!elegidos.length) return false
        for (let i = 0; i < elegidos.length; i++) {
          if (elegidos[i].puntos && elegidos[i].puntos.length && !elegidos[i].listo) return false
        }
        return true
      },

      motivoEliminacionDesdeTicket () {
        const folio = this.ticket && this.ticket.idticket ? this.ticket.idticket : ''
        const texto = (this.firstHistorial && this.firstHistorial.motivo) || (this.ticket && this.ticket.motivo) || ''
        const limpio = String(texto).replace(/\s+/g, ' ').trim()
        const base = 'Ticket ' + folio + (limpio ? '. ' + limpio : '')
        return base.slice(0, 500)
      },

      textoRespuestaAdeudos (elegidos) {
        const lineas = []
        for (let i = 0; i < elegidos.length; i++) {
          const item = elegidos[i]
          lineas.push(item.nombre + ' (' + (item.matricula || 'sin matrícula') + '), ' + item.grupo + ': ' + this.formatMoney(item.adeudo))
        }
        return 'Se eliminó el adeudo:\n' + lineas.join('\n')
      },

      async eliminarAdeudosYResponder () {
        const elegidos = (this.adeudosTicket || []).filter((item) => {
          return this.adeudosSeleccionados.indexOf(this.claveAdeudo(item)) !== -1
        })
        if (!elegidos.length) return
        const pendiente = (this.historial || []).filter((fila) => Number(fila.estatus) === 0).pop() || this.lastHistorial
        if (!pendiente || !pendiente.idhistorial_ticket) {
          this.validarError('No hay una respuesta pendiente en este ticket.')
          return
        }
        this.eliminandoAdeudo = true
        this.cargar = true
        const motivo = this.motivoEliminacionDesdeTicket()
        try {
          for (let i = 0; i < elegidos.length; i++) {
            const item = elegidos[i]
            await this.$http.put('eliminacion-adeudos.adeudo/' + item.id_alumno, {
              id_grupo: item.id_grupo,
              accion: 'eliminar',
              motivo: motivo,
            })
          }
          this.respuesta = this.textoRespuestaAdeudos(elegidos)
          await this.publicarRespuestaAdmin(pendiente, this.respuesta)
          if (this.dialogRespuesta) this.cargarAdeudosTicket()
        } catch (error) {
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'No se pudo eliminar el adeudo.'
          this.validarError(msg)
          this.cargar = false
        } finally {
          this.eliminandoAdeudo = false
        }
      },

      horaCorta (hora) {
        const texto = String(hora || '')
        return texto.length >= 5 ? texto.slice(0, 5) : texto
      },

      horaAmPm (hora) {
        const corta = this.horaCorta(hora)
        const partes = corta.split(':')
        let h = Number(partes[0])
        const minuto = partes[1] || '00'
        if (!Number.isFinite(h)) return corta
        const turno = h >= 12 ? 'pm' : 'am'
        if (h === 0) h = 12
        else if (h > 12) h = h - 12
        return h + ':' + minuto + ' ' + turno
      },

      fechaRelojLegible (fecha) {
        const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
        const partes = String(fecha || '').slice(0, 10).split('-')
        const mes = meses[Number(partes[1]) - 1]
        if (!mes || !partes[2]) return String(fecha || '')
        return Number(partes[2]) + ' de ' + mes
      },

      fraseReloj () {
        const data = this.relojPropuesta || {}
        const tipo = data.tipo === 'salida' ? 'salida' : 'entrada'
        const fecha = data.fecha ? ' del ' + this.fechaRelojLegible(data.fecha) : ''
        const pide = this.horaAmPm(data.hora)
        const nombre = data.persona && data.persona.nombre_completo ? data.persona.nombre_completo : 'El usuario'
        if (data.crear) {
          return nombre + ' no cuenta con ' + tipo + fecha + '. Se agregaría esta hora: ' + pide + '. ¿Estás seguro?'
        }
        const actual = this.horaAmPm(data.objetivo && data.objetivo.hora)
        return 'La hora de ' + tipo + ' de ' + nombre + fecha + ' es ' + actual + '. Se actualizaría a ' + pide + '. ¿Estás seguro?'
      },

      textoTicketReloj () {
        const partes = []
        const lista = this.historial || []
        for (let i = 0; i < lista.length; i++) {
          const motivo = lista[i] && lista[i].motivo
          if (motivo) partes.push(String(motivo))
        }
        if (!partes.length && this.ticket && this.ticket.motivo) partes.push(String(this.ticket.motivo))
        return partes.join('\n')
      },

      cargarRelojTicket () {
        if (!this.puedeCorregirReloj) {
          this.relojPropuesta = null
          return Promise.resolve()
        }
        this.cargandoReloj = true
        return this.$http.post('tickets.reloj.consultar', {
          texto: this.textoTicketReloj(),
          fecha_ticket: this.ticket && this.ticket.fecha_apertura,
          id_trabajador: this.relojTrabajador || 0,
          idticket: this.ticket && this.ticket.idticket,
          nombre_solicitante: (this.ticket && this.ticket.nombre_completo) || '',
        }).then((response) => {
          this.relojPropuesta = response.data || null
          const persona = this.relojPropuesta && this.relojPropuesta.persona
          if (persona && persona.id_trabajador) this.relojTrabajador = persona.id_trabajador
          const rechazo = this.relojPropuesta && this.relojPropuesta.rechazo
          if (rechazo && (!this.respuesta || this.respuesta === this.relojRechazoAuto)) {
            this.relojRechazoAuto = rechazo
            this.respuesta = rechazo
          }
        }).catch((error) => {
          this.relojPropuesta = null
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'No se pudo consultar el reloj.'
          this.validarError(msg)
        }).finally(() => {
          this.cargandoReloj = false
        })
      },

      elegirTrabajadorReloj (id) {
        if (!id || Number(id) === Number(this.relojTrabajador)) return
        this.relojTrabajador = id
        this.relojPorAplicar = null
        if (this.respuesta === this.relojRechazoAuto) this.respuesta = ''
        this.cargarRelojTicket()
      },

      textoRespuestaReloj (aceptado) {
        const data = this.relojPropuesta || {}
        const nombre = data.persona && data.persona.nombre_completo ? data.persona.nombre_completo : 'la persona'
        const tipo = data.tipo || 'checada'
        const fecha = data.fecha || ''
        if (!aceptado) {
          return 'No se corrigió el reloj de ' + nombre + (fecha ? ' del ' + fecha : '') + '.'
        }
        const verbo = data.crear ? 'Se agregó' : 'Se corrigió'
        return verbo + ' la ' + tipo + ' de ' + nombre + (fecha ? ' del ' + fecha : '') + '. Quedó a las ' + this.horaCorta(data.hora) + '.'
      },

      aceptarReloj () {
        const data = this.relojPropuesta
        if (!data || !data.listo || !data.persona) return
        const objetivo = data.objetivo || {}
        const sucursal = Number(objetivo.id_sucursal) || Number(this.ticket && this.ticket.id_suc) || Number(data.persona.id_plantel) || 0
        const plantel = Number(data.persona.id_plantel) || sucursal
        this.relojPorAplicar = {
          id_trabajador: data.persona.id_trabajador,
          fecha: data.fecha,
          hora: data.hora,
          id_registro: data.crear ? 0 : objetivo.id,
          id_sucursal: sucursal,
          id_plantel: plantel,
          tipo: data.tipo,
          motivo: this.motivoEliminacionDesdeTicket(),
        }
        this.respuesta = this.textoRespuestaReloj(true)
      },

      rechazarReloj () {
        if (!this.relojPropuesta) return
        this.relojPorAplicar = null
        if (this.relojPropuesta.rechazo) {
          this.respuesta = this.relojPropuesta.rechazo
          return
        }
        if (!this.relojPropuesta.persona) return
        this.respuesta = this.textoRespuestaReloj(false)
      },

      textoTicketGrupo () {
        return (this.firstHistorial && this.firstHistorial.motivo) || (this.ticket && this.ticket.motivo) || ''
      },

      cargarGrupoTicket () {
        if (!this.puedeAbrirGrupo) {
          this.grupoPropuesta = null
          return Promise.resolve()
        }
        this.cargandoGrupo = true
        const alumnos = this.alumnos || []
        const gruposAlumno = []
        for (let i = 0; i < alumnos.length; i++) {
          gruposAlumno.push({
            id_grupo: alumnos[i].id_grupo,
            grupo: alumnos[i].grupo,
          })
        }
        return this.$http.post('tickets.grupo.consultar', {
          texto: this.textoTicketGrupo(),
          id_grupo: this.grupoElegido || 0,
          alumnos: gruposAlumno,
        }).then((response) => {
          this.grupoPropuesta = response.data || null
          const elegido = this.grupoPropuesta && this.grupoPropuesta.id_grupo
          if (elegido) this.grupoElegido = elegido
        }).catch((error) => {
          this.grupoPropuesta = null
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'No se pudo revisar el grupo.'
          this.validarError(msg)
        }).finally(() => {
          this.cargandoGrupo = false
        })
      },

      elegirGrupoTicket (id) {
        if (!id || Number(id) === Number(this.grupoElegido)) return
        this.grupoElegido = id
        this.grupoPorAplicar = null
        this.cargarGrupoTicket()
      },

      aceptarGrupo () {
        const data = this.grupoPropuesta
        if (!data) return
        if (data.tipo === 'cambios') {
          this.grupoPorAplicar = data.listo
            ? {
                tipo: 'cambios',
                accion: data.accion || '',
                id_grupo: data.id_siguiente || data.id_grupo || 0,
                id_plantel: data.id_plantel || 0,
                id_ciclo: data.id_ciclo || 0,
                grupo: data.grupo_siguiente || '',
              }
            : null
          this.respuesta = data.respuesta_si || 'Buen día, el grupo de cambios se ha abierto, saludos!'
          return
        }
        this.grupoPorAplicar = data.listo && data.id_grupo ? { id_grupo: data.id_grupo } : null
        this.respuesta = data.respuesta_si || 'Buen día, el grupo que solicita cuenta con los requisitos de apertura, el grupo se ha abierto, saludos!'
      },

      rechazarGrupo () {
        if (!this.grupoPropuesta) return
        this.grupoPorAplicar = null
        this.respuesta = this.grupoPropuesta.respuesta_no || 'No se abrió el grupo.'
      },

      cargarAlumnoTicket () {
        if (!this.puedeCorregirAlumno) return
        this.cargandoAlumno = true
        this.$http.post('tickets.alumno.consultar', {
          texto: this.textoTicketGrupo(),
          alumnos: this.alumnos || [],
        }).then((response) => {
          this.alumnoPropuesta = response.data || null
        }).catch((error) => {
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'No se pudo revisar al alumno.'
          this.validarError(msg)
        }).finally(() => {
          this.cargandoAlumno = false
        })
      },

      aceptarAlumno () {
        const data = this.alumnoPropuesta
        this.alumnoPorAplicar = { id_alumno: data.alumno.id_alumno, cambios: data.cambios }
        this.respuesta = data.respuesta_si
      },

      rechazarAlumno () {
        this.alumnoPorAplicar = null
        this.respuesta = this.alumnoPropuesta.respuesta_no
      },

      // "Nombre Apellido (matrícula)" -> separa la matrícula para mostrarla como etiqueta aparte.
      partirNombreMatricula (texto) {
        const m = String(texto || '').match(/^(.*)\s\(([^)]+)\)$/)
        return m ? { nombre: m[1], matricula: m[2] } : { nombre: texto, matricula: '' }
      },

      // Solo para Habilitación de acceso; el servidor decide quién puede (Sistemas TI) y si el texto nombra una sucursal.
      cargarSucursalTicket () {
        const etiqueta = String((this.ticket && this.ticket.motivo_concepto) || '').trim()
        if (!this.puedeBotonesTicket || (etiqueta !== 'Habilitación de acceso' && !pideSucursalPropia(this.textoTicketGrupo()))) return
        this.revisandoAcceso++
        this.$http.post('tickets.sucursal.consultar', {
          texto: this.textoTicketGrupo(),
          id_usuario: this.ticket.id_usuario,
        }).then((response) => {
          this.sucursalPropuesta = response.data || null
          const opciones = (this.sucursalPropuesta && this.sucursalPropuesta.opciones) || []
          this.sucursalElegida = opciones.length === 1 ? opciones[0] : null
        }).catch(() => {
          this.sucursalPropuesta = null
        }).finally(() => {
          this.revisandoAcceso--
        })
      },

      aceptarSucursal () {
        const sucursal = this.sucursalElegida
        if (sucursal.ya_tiene) {
          this.sucursalPorAplicar = null
          this.respuesta = 'Buen día, ya cuenta con acceso a ' + sucursal.plantel + '. Por favor cierre sesión y vuelva a entrar para que le aparezca. Saludos!'
          return
        }
        this.sucursalPorAplicar = { idusuario: this.sucursalPropuesta.usuario.idusuario, idplantel: sucursal.idplantel }
        this.respuesta = 'Buen día, se le otorgó acceso a ' + sucursal.plantel + '. Por favor cierre sesión y vuelva a entrar para que le aparezca. Saludos!'
      },

      rechazarSucursal () {
        this.sucursalPorAplicar = null
        this.respuesta = 'Buen día, no fue posible otorgar el acceso a ' + this.sucursalElegida.plantel + '. Saludos!'
      },

      // Mismo motivo que sucursal; el servidor decide si el texto pide contraseña y quién puede (Sistemas TI).
      cargarContrasenaTicket () {
        if (!this.puedeBotonesTicket || String((this.ticket && this.ticket.motivo_concepto) || '').trim() !== 'Habilitación de acceso') return
        this.revisandoAcceso++
        this.$http.post('tickets.contrasena.consultar', {
          texto: this.textoTicketGrupo(),
          alumnos: this.alumnos || [],
        }).then((response) => {
          this.contrasenaPropuesta = response.data || null
          const personas = (this.contrasenaPropuesta && this.contrasenaPropuesta.personas) || []
          this.contrasenaPersona = personas.length === 1 ? personas[0] : null
        }).catch(() => {
          this.contrasenaPropuesta = null
        }).finally(() => {
          this.revisandoAcceso--
        })
      },

      aceptarContrasena () {
        const persona = this.contrasenaPersona
        this.contrasenaPorAplicar = { id_usuario: persona.id_usuario }
        this.respuesta = 'Buen día, se restableció la contraseña de ' + persona.nombre + '.\n\nUsuario: ' + persona.usuario +
          '\nContraseña temporal: ' + MARCA_CONTRASENA + '\n\nAl entrar, el sistema le pedirá cambiarla por una nueva. Saludos!'
      },

      rechazarContrasena () {
        this.contrasenaPorAplicar = null
        this.respuesta = 'Buen día, no fue posible restablecer la contraseña. Saludos!'
      },

      // Solo para Cambio de vendedora; el servidor decide quién puede.
      cargarVendedoraTicket () {
        if (!this.puedeBotonesTicket || String((this.ticket && this.ticket.motivo_concepto) || '').trim() !== 'Cambio de vendedora') return
        this.vendedoraPropuesta = { cargando: true, opciones: [] }
        this.$http.post('tickets.vendedora.consultar', {
          texto: this.textoTicketGrupo(),
          alumnos: this.alumnos || [],
          id_usuario: this.ticket.id_usuario,
        }).then((response) => {
          this.vendedoraPropuesta = response.data || null
          const opciones = (this.vendedoraPropuesta && this.vendedoraPropuesta.opciones) || []
          this.vendedoraElegida = opciones.length === 1 ? opciones[0] : null
        }).catch(() => {
          this.vendedoraPropuesta = null
        })
      },

      aceptarVendedora () {
        const data = this.vendedoraPropuesta
        this.vendedoraPorAplicar = { id_alumno: data.alumno.id_alumno, id_vendedora: this.vendedoraElegida.id_usuario }
        this.respuesta = 'Buen día, la venta de ' + data.alumno.nombre + ' quedó a nombre de ' + this.vendedoraElegida.nombre + '. Saludos!'
      },

      rechazarVendedora () {
        this.vendedoraPorAplicar = null
        this.respuesta = 'Buen día, no fue posible cambiar la vendedora de ' + this.vendedoraPropuesta.alumno.nombre + '. Saludos!'
      },

      // Cualquier motivo: el servidor decide por el texto si piden códigos Cambridge.
      cargarCambridgeTicket () {
        const texto = String(this.textoTicketGrupo()).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
        if (!this.puedeBotonesTicket || !PIDE_CODIGOS_CAMBRIDGE.test(texto)) return
        this.cambridgePropuesta = { cargando: true }
        this.$http.post('tickets.cambridge.consultar', { texto: this.textoTicketGrupo() }).then((response) => {
          this.cambridgePropuesta = response.data || null
        }).catch(() => {
          this.cambridgePropuesta = null
        })
      },

      aceptarCambridge () {
        const data = this.cambridgePropuesta
        if (data.accion === 'responder') {
          this.cambridgePorAplicar = null
          this.respuesta = data.respuesta
          return
        }
        this.cambridgePorAplicar = { escuela: data.escuela, id_alumno: data.id_alumno, idcertificacion: data.idcertificacion, nombre: data.alumno }
        this.respuesta = MARCA_CAMBRIDGE
      },

      rechazarCambridge () {
        this.cambridgePorAplicar = null
        this.respuesta = 'Buen día, por el momento no fue posible asignar los códigos Cambridge. Saludos!'
      },

      async saveRespuestaAdmin(respuestas){
        if(this.respuesta != ''){
          if (this.relojPorAplicar) {
            this.cargar = true
            try {
              await this.$http.post('tickets.reloj.aplicar', this.relojPorAplicar)
              this.relojPorAplicar = null
            } catch (error) {
              const msg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : 'No se pudo corregir el reloj.'
              this.validarError(msg)
              this.cargar = false
              return
            }
          }
          if (this.grupoPorAplicar) {
            this.cargar = true
            try {
              await this.$http.post('tickets.grupo.aplicar', this.grupoPorAplicar)
              this.grupoPorAplicar = null
            } catch (error) {
              const msg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : 'No se pudo abrir el grupo.'
              this.validarError(msg)
              this.cargar = false
              return
            }
          }
          if (this.alumnoPorAplicar) {
            this.cargar = true
            try {
              await this.$http.post('tickets.alumno.aplicar', this.alumnoPorAplicar)
              this.alumnoPorAplicar = null
            } catch (error) {
              const msg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : 'No se pudo corregir al alumno.'
              this.validarError(msg)
              this.cargar = false
              return
            }
          }
          if (this.sucursalPorAplicar) {
            this.cargar = true
            try {
              await this.$http.post('tickets.sucursal.aplicar', this.sucursalPorAplicar)
              this.sucursalPorAplicar = null
            } catch (error) {
              const msg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : 'No se pudo dar acceso a la sucursal.'
              this.validarError(msg)
              this.cargar = false
              return
            }
          }
          if (this.contrasenaPorAplicar) {
            this.cargar = true
            try {
              const { data } = await this.$http.post('tickets.contrasena.aplicar', this.contrasenaPorAplicar)
              this.contrasenaPorAplicar = null
              this.respuesta = this.respuesta.replace(MARCA_CONTRASENA, data.contrasena)
            } catch (error) {
              const msg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : 'No se pudo restablecer la contraseña.'
              this.validarError(msg)
              this.cargar = false
              return
            }
          }
          if (this.vendedoraPorAplicar) {
            this.cargar = true
            try {
              await this.$http.post('tickets.vendedora.aplicar', this.vendedoraPorAplicar)
              this.vendedoraPorAplicar = null
            } catch (error) {
              const msg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : 'No se pudo reasignar la vendedora.'
              this.validarError(msg)
              this.cargar = false
              return
            }
          }
          if (this.cambridgePorAplicar) {
            this.cargar = true
            try {
              const { data } = await this.$http.post('tickets.cambridge.aplicar', this.cambridgePorAplicar)
              this.cambridgePorAplicar = null
              this.respuesta = this.respuesta.replace(MARCA_CAMBRIDGE, data.respuesta)
            } catch (error) {
              const msg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : 'No se pudo asignar el código Cambridge.'
              this.validarError(msg)
              this.cargar = false
              return
            }
          }
          await this.publicarRespuestaAdmin(respuestas, this.respuesta)
        } else {
          this.validarErrorDirecto(' Respuesta vacia ')
        }
      },

      async publicarRespuestaAdmin (respuestas, texto) {
        const respuestaTexto = String(texto || '').trim()
        if (!respuestaTexto) {
          this.validarErrorDirecto(' Respuesta vacia ')
          return
        }
        let fotos = []
        if(this.vistaPrevias.length){
            let respuesta = await this.subirFotosServidor( )
            fotos = respuesta.data
          }
        var payload = {
          idhistorial_ticket: respuestas.idhistorial_ticket,
          motivo: this.ticket.motivo,
          respuestaauxi: '',
          respuesta: respuestaTexto,
          idticket: this.ticket.idticket,
          estatus:0,
          id_usuario: this.ticket.id_usuario,
          folio: this.ticket.idticket,
          fotos,
          idauxi_area:        this.lastHistorial.idauxi_area,
          idjefe_area:        this.getdatosUsuarioERPERP.id_usuario,
        }

        var estatus = {estatus: 5}

        return this.$http.put('historial_tickets.update/'+respuestas.idhistorial_ticket, payload).then(response=>{
          return this.$http.put('tickets.update.estatus/'+this.ticket.idticket,estatus).then(response=>{
            this.mensaje= ''
            this.respuesta = ''
            this.dialogRespuesta = false
            this.vistaPrevias = []
            this.obtenerTickets(true, false)
          })
        }).catch( error =>{
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : error
          this.validarError(msg)
        }).finally( () => { this.cargar = false })
      },

      //Ver Ticket
      historialTicket(value){
        this.cargar = true
        this.ticket = value
        this.historial = []
        this.cargarInfoAlumno()
        this.$http.get('historial_tickets.estatus/'+this.ticket.idticket).then(response=>{
          for(const i in response.data.HistorialTicket){
            response.data.HistorialTicket[i].fecha = moment(response.data.HistorialTicket[i].fecha).format('MMMM Do YYYY, h:mm:ss a');
            response.data.HistorialTicket[i].fecharespuesta = moment(response.data.HistorialTicket[i].fecharespuesta).format('MMMM Do YYYY, h:mm:ss a');
            //esta es la fecha y hora en la que se comenzo el registro de respuestas
            if(response.data.HistorialTicket[i].fecharespuesta == 'marzo 4º 2024, 3:31:27 pm'){
              response.data.HistorialTicket[i].fecharespuesta = ''
            }
            this.historial.push(response.data.HistorialTicket[i])
          }
          this.firstHistorial = response.data.HistorialTicket[0]
          this.lastHistorial = response.data.HistorialTicket[response.data.HistorialTicket.length - 1]
          this.mensajes = response.data.notas
          this.historialAsignacion = response.data.asignacion
          this.alumnos = response.data.alumnos
          this.dialogHistorial = true
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      comentarTicket (item) {
        this.ticket = item
        this.historial = []
        this.alumnos = []
        this.mensajes = []
        this.mensajeRechazo = ''
        this.cargar = true
        this.$http.get('historial_tickets.estatus/' + item.idticket).then(response => {
          const historialTicket = Array.isArray(response.data.HistorialTicket) ? response.data.HistorialTicket : []
          this.historial = historialTicket.map((h) => {
            const fecharespuesta = moment(h.fecharespuesta).format('MMMM Do YYYY, h:mm:ss a')
            return {
              ...h,
              evidencias: h.evidencias || [],
              evidenciasRespuesta: h.evidenciasRespuesta || [],
              fecha: moment(h.fecha).format('MMMM Do YYYY, h:mm:ss a'),
              fecharespuesta: fecharespuesta == 'marzo 4º 2024, 3:31:27 pm' ? '' : fecharespuesta,
            }
          })
          this.mensajes = response.data.notas || []
          this.alumnos = response.data.alumnos || []
          this.dialogContenidoTicket = true
        }).catch(error => {
          this.validarError(error.response.data.message)
        }).finally(() => { this.cargar = false })
      },

      // Sirve para cargar las notas del ticket
      cargarNotas () {
        this.$http.get('tickets.notas/' + this.ticket.idticket).then(response=>{
          this.mensajes        = response.data
          this.cargar         = false
          this.dialogMensajes  = true
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      cargarInfoAlumno () {
        this.errorInfoAlumno = ''
        if (!this.esTicketAlumno || !this.ticket || !this.ticket.id_usuario) {
          this.infoAlumno = null
          this.cargandoInfoAlumno = false
          return Promise.resolve()
        }
        this.cargandoInfoAlumno = true
        return fetchInfoAlumno(this.$http, this.ticket.id_usuario).then((data) => {
          this.infoAlumno = data
        }).catch((error) => {
          this.infoAlumno = null
          this.errorInfoAlumno = (error.response && error.response.data && error.response.data.message)
            || 'No se pudo obtener la información del alumno'
        }).finally(() => {
          this.cargandoInfoAlumno = false
        })
      },

      // Subir la nota del ticket
      enviarMensaje () {
        if(this.mensajeRechazo != '' && this.mensajeRechazo != null){
          this.cargar = true
          let payload = {
            idticket:    this.ticket.idticket,
            id_usuario:  this.getdatosUsuarioERPERP.iderp,
            nota:        this.mensajeRechazo,
          }

          this.$http.post('tickets.nota',payload).then(response=>{
            this.dialogRechazar = false
            this.mensajeRechazo = ''
            this.dialogMensajes = true
            this.mensajes       = []
            this.cargarNotas()
            this.cargar = false
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        }else{
          this.error = 'Ingresa un mensaje'
          this.dialogError = true
          this.dialogRechazar = false
        }
      },  

      reasignarTicket () {
        this.notaReasignacion = ''
        this.dialogReasignar = true
      },

      /**
       * Resuelve el puesto "jefe de …" y el usuario jefe de área del departamento.
       * Operaciones → puesto Jefe de operaciones → usuario 568 (María Esther Segura Canales).
       * Comercial → usuario 32 (Armando Molina).
       */
      estiloBotonDepartamento (departamento) {
        const nombre = this.normalizarTexto(departamento)
        if (nombre.includes('sistemas') || nombre.includes(' ti') || nombre === 'ti') {
          return { abreviatura: 'TI', color: 'indigo' }
        }
        if (nombre.includes('operacion')) {
          return { abreviatura: 'OPS', color: 'orange' }
        }
        if (nombre.includes('comercial')) {
          return { abreviatura: 'COM', color: 'teal' }
        }
        if (nombre.includes('recursos humanos') || nombre === 'rh') {
          return { abreviatura: 'RH', color: 'purple' }
        }
        if (nombre.includes('administracion') || nombre.includes('admin')) {
          return { abreviatura: 'ADM', color: 'blue-grey' }
        }
        if (nombre.includes('academico')) {
          return { abreviatura: 'ACA', color: 'cyan' }
        }
        if (nombre.includes('desarrollo')) {
          return { abreviatura: 'DEV', color: 'deep-purple' }
        }
        if (nombre.includes('control interno')) {
          return { abreviatura: 'CI', color: 'brown' }
        }
        const corto = (departamento || '').toString().trim()
        return {
          abreviatura: corto.length > 4 ? corto.slice(0, 3).toUpperCase() : corto.toUpperCase(),
          color: 'grey darken-1',
        }
      },

      resolverJefeAreaDepartamento (depto) {
        if (!depto) return null
        const puestos = this.filtrarPuestosPermitidos(depto.puestos || [])
          .filter((p) => Array.isArray(p.jefes) && p.jefes.length)
        if (!puestos.length) return null

        const nombreDepto = this.normalizarTexto(depto.departamento)
        const esOperaciones = nombreDepto.includes('operacion')

        const puestosJefe = puestos.filter((p) => {
          const n = this.normalizarTexto(this.getEtiquetaPuesto(p))
          return n.includes('jefe')
        })

        let puesto = puestosJefe.find((p) => {
          const n = this.normalizarTexto(this.getEtiquetaPuesto(p))
          const resto = n.replace(/^jefe(a)?\s*(de\s*)?/, '').trim()
          return (
            (nombreDepto && resto && (resto.includes(nombreDepto) || nombreDepto.includes(resto))) ||
            (esOperaciones && n.includes('operacion'))
          )
        })

        if (!puesto && puestosJefe.length) puesto = puestosJefe[0]
        if (!puesto) puesto = puestos[0]

        let jefe = null
        const idJefePreferido = esOperaciones
          ? 568
          : (nombreDepto.includes('comercial') ? 32 : null)
        if (idJefePreferido) {
          const esPreferido = (j) => Number(j.id_usuario) === idJefePreferido
          jefe = (puesto.jefes || []).find(esPreferido) || null
          if (!jefe) {
            const puestoConPreferido = puestos.find((p) => (p.jefes || []).some(esPreferido))
            if (puestoConPreferido) {
              puesto = puestoConPreferido
              jefe = puesto.jefes.find(esPreferido)
            }
          }
        }
        if (!jefe) jefe = (puesto.jefes || [])[0] || null
        if (!jefe) return null

        return {
          iddepartamento: depto.iddepartamento,
          departamento: depto.departamento,
          puesto,
          jefe,
        }
      },

      confirmarReasignarDepartamento (item) {
        if (!item || !item.jefe || !item.puesto) {
          this.validarError('No se encontró jefe de área para ese departamento')
          return
        }
        if (this.isPuestoBloqueado(item.puesto)) {
          this.validarError('No tienes permiso para seleccionar Auxiliar de recursos humanos')
          return
        }

        // Solo Operaciones: permite elegir puesto y usuario antes de confirmar
        if (this.normalizarTexto(item.departamento).includes('operacion')) {
          this.abrirSeleccionOperaciones(item)
          return
        }

        this.notaReasignacion = ''
        this.reasignacionPendiente = item
        this.dialogConfirmarReasignar = true
      },

      abrirSeleccionOperaciones (item) {
        const depto = (this.areas || []).find(
          (a) => Number(a.iddepartamento) === Number(item.iddepartamento)
        )
        if (!depto) {
          this.validarError('No se encontró el departamento de Operaciones')
          return
        }
        this.opsDepartamento = depto
        this.opsPuesto = item.puesto || null
        this.opsUsuario = null
        this.dialogSeleccionOps = true
        this.$nextTick(() => {
          this.opsUsuario = item.jefe || null
        })
      },

      cancelarSeleccionOperaciones () {
        this.dialogSeleccionOps = false
        this.opsDepartamento = null
        this.opsPuesto = null
        this.opsUsuario = null
      },

      confirmarSeleccionOperaciones () {
        if (!this.opsPuesto || !this.opsUsuario) {
          this.validarError('Selecciona un puesto y un usuario')
          return
        }
        if (this.isPuestoBloqueado(this.opsPuesto)) {
          this.validarError('No tienes permiso para seleccionar Auxiliar de recursos humanos')
          return
        }
        this.reasignacionPendiente = {
          iddepartamento: this.opsDepartamento.iddepartamento,
          departamento: this.opsDepartamento.departamento,
          puesto: this.opsPuesto,
          jefe: this.opsUsuario,
        }
        this.dialogSeleccionOps = false
        this.opsDepartamento = null
        this.opsPuesto = null
        this.opsUsuario = null
        this.notaReasignacion = ''
        this.dialogConfirmarReasignar = true
      },

      cancelarReasignarDepartamento () {
        this.dialogConfirmarReasignar = false
        this.reasignacionPendiente = null
      },

      aceptarReasignarDepartamento () {
        const nota = String(this.notaReasignacion || '').trim()
        if (!nota) {
          this.validarError('Agrega una nota para reasignar el ticket')
          return
        }
        const item = this.reasignacionPendiente
        if (!item || !item.jefe || !item.puesto) {
          this.dialogConfirmarReasignar = false
          this.reasignacionPendiente = null
          this.validarError('Datos vacios')
          return
        }
        this.area = {
          iddepartamento: item.iddepartamento,
          departamento: item.departamento,
          puestos: [item.puesto],
        }
        this.puesto = item.puesto
        this.jefe = item.jefe
        this.reasignar()
      },

      reasignar() {
        const nota = String(this.notaReasignacion || '').trim()
        if (!nota) {
          this.validarError('Agrega una nota para reasignar el ticket')
          return
        }
        if(this.area && this.jefe){
          if (this.isPuestoBloqueado(this.puesto)) {
            this.validarError('No tienes permiso para seleccionar Auxiliar de recursos humanos')
            return
          }
          if (this.cargar) return
          this.cargar = true
          this.$http.post('tickets.nota', {
            idticket: this.ticket.idticket,
            id_usuario: this.getdatosUsuarioERPERP.iderp,
            nota: nota,
          }).then(() => {
            this.ticket.idhistorial_ticket = this.lastHistorial.idhistorial_ticket
            this.ticket.id_area_viejo = this.ticket.id_area
            this.ticket.idjefe_area_viejo = this.ticket.idjefe_area
            this.ticket.id_area     = this.puesto.idpuesto
            this.ticket.idjefe_area = this.jefe.id_usuario
            this.ticket.estatus     = 2
            this.ticket.idauxi_area = 0

            this.$http.put('tickets.update.asignacion/'+this.ticket.idticket, this.ticket).then(response=>{
              this.dialogAsignarAux = false
              this.dialogReasignar = false
              this.dialogRespuesta = false
              this.dialogRespuestaAuxi = false
              this.dialogConfirmarReasignar = false
              this.area = null
              this.jefe = null
              this.puesto = null
              this.reasignacionPendiente = null
              this.notaReasignacion = ''
              this.validarSuccess('Ticket reasignado correctamente')
              this.initialize()
            }).catch( error =>{
              this.validarError( error.response.data.message )
            }).finally( () => { this.cargar = false })
          }).catch( error =>{
            this.validarError( error.response.data.message )
            this.cargar = false
          })

        }else{
          this.validarError( 'Datos vacios' )
        }
      },

      updateTicketEstatus() {
          this.cargar = true
          let payload = {
            idticket:    this.ticket.idticket,
            estatus:     3
          }
          this.$http.post('tickets.update.estatus', payload).then(response=>{
            this.dialogAceptar = false
            this.initialize()
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
      },
      saveFecha( value ){
        this.cargar = true

        this.$http.post('tickets.fecha.entrega',value).then(response=>{
          this.cargar = false
          this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      /*MANEJO DE IMAGENES*/
      subirFotosServidor( ){
        let formData = new FormData();

        for( const i in this.vistaPrevias ){
          formData.append('file', this.vistaPrevias[i].file )
        }

        return new Promise((resolve,reject)=>{
          // obtener la extensión del archivo
          // Hacemos la petición
          this.$http.post(`tickets.subir.evidencia`, formData ).then(response=>{
            resolve( response )
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        })
      },
      cargarFotos(){
        if(this.files.length < 1){
          return
        }

        this.files.forEach((element, index) => {
          // creamos una variable tipo FormData
          let formData = new FormData();
          //se crea el objeto y se le agrega como un apendice el archivo 
          formData.append('file', element);
          //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
          if(element.size > 26214400){ //26214400 = 25MB
              this.validarErrorDirecto('El archivo sobrepasa el limite del peso, max 25 MB')
          } else {
              this.getBase64(element, formData)
          }
        })
      },
      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
        const tipoArchivo = clasificarArchivoEvidencia(file.name)
        me.vistaPrevias.push({
                url: reader.result, 
                formData: formData, 
                image_name: file.name,
                video : tipoArchivo.video,
                pdf: tipoArchivo.pdf,
                file
            })
        };
      },
      eliminarFoto(value){
        this.vistaPrevias.forEach((element, index)=>{
          if(element.url == value){
            this.vistaPrevias.splice(index,1);
          }
        })
      },
      convertFile(dataurl, filename) {
                var arr = dataurl.split(","),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);

                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }

                return new File([u8arr], filename, { type: mime });
      },
      createFile(file) {
          if (file.size > 10000000) {
              alert("please check file size no over 5 MB.");
              this.dragging = false;
              return;
          }

          this.file = file;
          this.archivos = file;
          this.getBase64(this.archivos);
          this.dragging = false;
      },
      async pegar(event) {
          if (event.code == "KeyV") {
              const { type, value } = await Clipboard.read();

              // Validamos que sea de tipo imagen
              if (type == "image/png") {
              // Convertimos el base64 en una imagen
              const file = this.convertFile(value, "imagen.png");
              this.createFile(file);
              }
          }
      },
      /*MANEJO DE ESTILOS Y OTROS*/
      itemRowBackground: function () {
        return ''
      },

      getColor (estatus) {
        if (estatus == 3) return 'red'
        else if (estatus == 1) return 'orange'
        else if (estatus == 2) return 'blue'
      },
      exportar () {
        this.cargar = true
        const params = this.buildTicketsQueryParams(true)
        this.$http
          .get('tickets.area/' + this.getdatosUsuarioERPERP.iderp, { params })
          .then((response) => {
            const body = response.data
            const rows = Array.isArray(body) ? body : (body && body.rows) ? body.rows : []
            this.aplicarFormatoFechasFilas(rows)
            this.exportExcel(rows, 'tickets_list')
          })
          .catch((error) => {
            const msg =
              error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : error.message || error
            this.validarError(msg)
          })
          .finally(() => {
            this.cargar = false
          })
      },
      /*MANEJO DE ERRORES*/
      validarSuccess( mensaje ){
        this.cargar = false
        this.parametros.mensaje      = mensaje
        this.parametros.dialogError  = true 
        this.parametros.color        = 'success'
        this.respuestaAlerta         = true 
      },
      validarError ( value ) {
        this.cargar = false
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.data.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        } else {
          this.parametros.mensaje      = value
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },
    },

  }
</script>

<style>
  /* Etiquetas y tabla de alumnos son solo informativas: sin sombreado ni cursor de clic. */
  .ticket-etiquetas .v-chip { cursor: default; }
  .ticket-etiquetas .v-chip::before { display: none; }
  .ticket-etiquetas tbody tr:hover { background: transparent !important; }
  /* Cuadros automáticos del ticket: el esqueleto se desvanece y entra el cuadro real en su mismo lugar. */
  .ticket-auto-enter-active{
    transition: opacity 200ms cubic-bezier(0.16, 1, 0.3, 1), transform 200ms cubic-bezier(0.16, 1, 0.3, 1);
  }
  .ticket-auto-leave-active{
    transition: opacity 120ms ease-in;
  }
  .ticket-auto-enter, .ticket-auto-leave-to{
    opacity: 0;
  }
  .ticket-auto-enter{
    transform: translateY(4px);
  }
  .ticket-auto-cargando .v-skeleton-loader__button{
    width: 44px;
    height: 28px;
  }
  @media (prefers-reduced-motion: reduce){
    .ticket-auto-enter-active, .ticket-auto-leave-active{
      transition: opacity 120ms linear;
    }
    .ticket-auto-enter{
      transform: none;
    }
  }
  .mensajeIzq{
    white-space: pre-line;
    background-color: rgb(238, 235, 235);
    border-radius: 0px 10px 10px 10px;
  }
  .mensajeDer{
    white-space: pre-line;
    background-color: rgb(193, 231, 243);
    border-radius: 10px 0px 10px 10px;
  }
  .style-1 {
    background-color: rgb(253, 169, 169);
  }
  .style-1:hover {
    background-color: rgb(238, 131, 131) !important;
  }

  .style-2 {
    background-color: #EB8DE3;
  }

  .style-2:hover {
    background-color: #EB8DE3 !important;
  }

  .ticket-area-metricas-bar {
    position: relative;
    gap: 8px 16px;
    overflow: hidden;
    border: 1px solid #b692ec;
    background: linear-gradient(90deg, #eadcfb 0%, #fbf8ff 45%, #e3f7e7 100%) !important;
    box-shadow: 0 4px 14px rgba(80, 45, 130, 0.18) !important;
  }

  .ticket-area-metricas-bar::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 7px;
    background: linear-gradient(180deg, #512da8 0%, #7e57c2 100%);
  }

  .ticket-area-metrica-ticket {
    min-width: 280px;
  }

  .ticket-area-metrica-icon {
    align-items: center;
    background: #d9c7f4;
    border: 1px solid #b692ec;
    border-radius: 999px;
    display: flex;
    height: 38px;
    justify-content: center;
    width: 38px;
  }

  .ticket-area-metrica-valor {
    font-size: 1rem;
    line-height: 1.25;
  }

  .ticket-area-promedio-chip {
    margin-left: auto;
    border: 1px solid #81c784 !important;
    box-shadow: 0 2px 8px rgba(46, 125, 50, 0.18);
  }

  /* Tarjeta de corrección de datos del alumno: se identifica como propuesta de IA, no como una nota más del ticket. */
  .ai-suggestion {
    border-color: #d9c7f4 !important;
    border-radius: 6px !important;
    overflow: hidden;
  }
  .ai-suggestion__head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    background: #f3edfb;
    border-bottom: 1px solid #e3d6f7;
    color: #512da8;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
  .ai-suggestion__body {
    padding: 16px;
  }
  .ai-suggestion__title {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 10px;
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .ai-suggestion__badge {
    font-family: 'Roboto Mono', ui-monospace, Consolas, monospace;
    font-size: 11px;
    font-weight: 500;
    color: #5e5a75;
    border: 1px solid #d8d4f0;
    border-radius: 3px;
    padding: 1px 6px;
  }
  .ai-suggestion__diff {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 14px;
    row-gap: 8px;
    margin: 0;
  }
  .ai-suggestion__diff dt {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #5e5a75;
    align-self: center;
  }
  .ai-suggestion__diff dd {
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
  }
  .ai-suggestion__diff del {
    color: #6b6782;
    text-decoration-color: #a39fbd;
  }
  .ai-suggestion__diff svg {
    flex: none;
    color: #7c77a0;
  }
  .ai-suggestion__diff ins {
    text-decoration: none;
    font-weight: 600;
    color: #2a1f86;
    background: #eeebff;
    border: 1px solid #cfc7fa;
    border-radius: 3px;
    padding: 3px 9px;
  }
  .ai-suggestion__actions {
    padding: 0 16px 16px;
  }

  /* Buscador compacto alineado con fechas */
  .ticket-area-buscar-compacto.v-text-field--outlined.v-input--dense .v-input__slot {
    min-height: 36px !important;
  }
  .ticket-area-buscar-compacto.v-text-field--outlined.v-input--dense .v-text-field__slot input {
    font-size: 0.8125rem;
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
</style>